import styled from "styled-components";

export const LoginMain = styled.div`
  position: relative;
  height: 100vh;
  background-color: #fff;
  @media (max-width: 767px) {
    height: auto;
  }
  &.register-main-login {
    @media (max-height: 800px) {
      height: auto;
    }
  }
  .login-main-block {
    display: flex;
    align-items: center;
    padding: 50px;
    position: relative;
    height: 100%;
    @media (max-width: 1499px) {
      padding: 30px;
    }
    @media (max-width: 991px) {
      padding: 30px 15px;
    }
    @media (max-width: 767px) {
      display: block;
    }
    .login-main-block-left {
      width: 60%;
      padding: 70px 100px;
      position: relative;
      height: 100%;
      @media (max-width: 1499px) {
        padding: 70px 70px 35px 70px;
      }
      @media (max-width: 991px) {
        padding: 35px 25px;
        width: 50%;
      }
      @media (max-width: 767px) {
        padding: 35px 15px 30px;
        width: 100%;
      }
      .login-main-block-left-link {
        position: absolute;
        top: 0px;
        left: 50%;
        transform: translate(-50%, 0);
        img {
          width: 230px;
          @media (max-width: 1199px) {
            width: 200px;
          }
          @media (max-width: 767px) {
            width: 170px;
          }
        }
      }
      .login-main-block-left-banner {
        width: 100%;
        height: 100%;
        padding-top: 15px;
        @media (max-width: 767px) {
          height: auto;
          padding-top: 30px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          @media (max-width: 767px) {
            width: 280px;
            height: auto;
            margin: 0 auto;
            display: table;
          }
        }
      }
      .title-block {
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%, 0);
        @media (max-width: 767px) {
          position: unset;
          text-align: center;
          transform: unset;
        }
        h1 {
          font-size: 40px;
          line-height: 40px;
          font-weight: 600;
          @media (max-width: 1499px) {
            font-size: 30px;
            line-height: 30px;
          }
          @media (max-width: 767px) {
            font-size: 26px;
            line-height: 26px;
          }
        }
      }
    }
    .login-main-block-right {
      width: 40%;
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: 991px) {
        width: 50%;
      }
      @media (max-width: 767px) {
        width: 100%;
      }
      .login-form-block {
        width: 500px;
        @media (max-width: 1199px) {
          width: 100%;
        }

        .login-form-block-title {
          text-align: center;
          h2 {
            color: #c00000;
            font-size: 40px;
            line-height: 50px;
            margin-bottom: 40px;
            font-weight: 600;
            @media (max-width: 1499px) {
              font-size: 30px;
              line-height: 30px;
              margin-bottom: 20px;
            }
            @media (max-width: 767px) {
              font-size: 26px;
              line-height: 26px;
            }
          }
        }
        .form-main {
          position: relative;
          &.sign-up-form {
            .form_signup {
              margin-bottom: 15px;
            }
          }
          .otp-block-input {
            display: flex;
            align-items: center;
            justify-content: center;
            input {
              width: 100%;
              height: 50px;
              border: 1px solid rgba(0, 0, 0, 0.1);
              border-radius: 10px;
              padding: 10px 10px 10px 10px;
              font-family: 'Mulish', serif;
              color: rgba(0, 0, 0, 0.3);
              font-size: 16px;
              line-height: 16px;
              margin: 0px 5px;
              box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
              text-align: center;
              &::placeholder {
                color: rgba(0, 0, 0, 0.3);
              }
              @media (max-width: 767px) {
                height: 40px;
              }
            }
          }
          .floating-label {
            display: none;
          }

          @media (max-width: 767px) {
            .floating-label {
                position: absolute;
                left: 55px;
                top: 14px;
                color: rgba(0, 0, 0, 0.3);
                font-size: 16px;
                pointer-events: none;
                transition: 0.2s ease all;
                display: block; /* <-- this is missing */
            }

            input.filled + .floating-label,
            input:focus + .floating-label {
              top: -10px;
              left: 10px;
              font-size: 12px;
              color: #d60000;
            }
          }

          .form_signup, .form_signup_new {
            position: relative;
            margin-bottom: 30px;
            padding: 0px;
            @media (max-width: 1499px) {
              margin-bottom: 20px;
            }

            .validationText {
              position: absolute;
              bottom: -17px;
              left: 0px;
            }
            input {
              width: 100%;
              height: 50px;
              border: 1px solid rgba(0, 0, 0, 0.1);
              border-radius: 10px;
              padding: 10px 10px 10px 55px;
              font-family: 'Mulish', serif;
              color: rgba(0, 0, 0, 0.3);
              font-size: 16px;
              line-height: 16px;
              box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
              &::placeholder {
                color: rgba(0, 0, 0, 0.3);
              }
              /* &::-webkit-calendar-picker-indicator {
                color: #c00000;
                opacity: 1;
                display: block;
                background: url('data:image/svg+xml,<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7 4.89548V5.39548H14.2H14.9C15.8139 5.39548 16.5 6.08163 16.5 6.99548V7.19548H3.5V6.99548C3.5 6.08163 4.18614 5.39548 5.1 5.39548H5.8H6.3V4.89548V4.19548C6.3 4.09911 6.32994 4.05765 6.34605 4.04154C6.36216 4.02543 6.40362 3.99548 6.5 3.99548C6.59638 3.99548 6.63784 4.02543 6.65395 4.04154C6.67006 4.05765 6.7 4.09911 6.7 4.19548V4.89548V5.39548H7.2H12.8H13.3V4.89548V4.19548C13.3 4.09911 13.3299 4.05765 13.3461 4.04154C13.3622 4.02543 13.4036 3.99548 13.5 3.99548C13.5964 3.99548 13.6378 4.02543 13.6539 4.04154C13.6701 4.05765 13.7 4.09911 13.7 4.19548V4.89548ZM5.1 16.9955C4.18614 16.9955 3.5 16.3093 3.5 15.3955V9.59548H16.5V15.3955C16.5 16.3093 15.8139 16.9955 14.9 16.9955H5.1ZM14.7 11.1955C14.7 10.8719 14.5899 10.5633 14.3611 10.3344C14.1322 10.1055 13.8236 9.99548 13.5 9.99548C13.1764 9.99548 12.8678 10.1055 12.6389 10.3344C12.4101 10.5633 12.3 10.8719 12.3 11.1955C12.3 11.5191 12.4101 11.8276 12.6389 12.0565C12.8678 12.2854 13.1764 12.3955 13.5 12.3955C13.8236 12.3955 14.1322 12.2854 14.3611 12.0565C14.5899 11.8276 14.7 11.5191 14.7 11.1955ZM14.7 13.9955C14.7 13.6719 14.5899 13.3633 14.3611 13.1344C14.1322 12.9055 13.8236 12.7955 13.5 12.7955C13.1764 12.7955 12.8678 12.9055 12.6389 13.1344C12.4101 13.3633 12.3 13.6719 12.3 13.9955C12.3 14.3191 12.4101 14.6276 12.6389 14.8565C12.8678 15.0854 13.1764 15.1955 13.5 15.1955C13.8236 15.1955 14.1322 15.0854 14.3611 14.8565C14.5899 14.6276 14.7 14.3191 14.7 13.9955ZM11.2 11.1955C11.2 10.8719 11.0899 10.5633 10.8611 10.3344C10.6322 10.1055 10.3236 9.99548 10 9.99548C9.67638 9.99548 9.36784 10.1055 9.13895 10.3344C8.91006 10.5633 8.8 10.8719 8.8 11.1955C8.8 11.5191 8.91006 11.8276 9.13895 12.0565C9.36784 12.2854 9.67638 12.3955 10 12.3955C10.3236 12.3955 10.6322 12.2854 10.8611 12.0565C11.0899 11.8276 11.2 11.5191 11.2 11.1955ZM11.2 13.9955C11.2 13.6719 11.0899 13.3633 10.8611 13.1344C10.6322 12.9055 10.3236 12.7955 10 12.7955C9.67638 12.7955 9.36784 12.9055 9.13895 13.1344C8.91006 13.3633 8.8 13.6719 8.8 13.9955C8.8 14.3191 8.91006 14.6276 9.13895 14.8565C9.36784 15.0854 9.67638 15.1955 10 15.1955C10.3236 15.1955 10.6322 15.0854 10.8611 14.8565C11.0899 14.6276 11.2 14.3191 11.2 13.9955ZM7.7 11.1955C7.7 10.8719 7.58994 10.5633 7.36105 10.3344C7.13216 10.1055 6.82362 9.99548 6.5 9.99548C6.17638 9.99548 5.86784 10.1055 5.63895 10.3344C5.41006 10.5633 5.3 10.8719 5.3 11.1955C5.3 11.5191 5.41006 11.8276 5.63895 12.0565C5.86784 12.2854 6.17638 12.3955 6.5 12.3955C6.82362 12.3955 7.13216 12.2854 7.36105 12.0565C7.58994 11.8276 7.7 11.5191 7.7 11.1955ZM7.7 13.9955C7.7 13.6719 7.58994 13.3633 7.36105 13.1344C7.13216 12.9055 6.82362 12.7955 6.5 12.7955C6.17638 12.7955 5.86784 12.9055 5.63895 13.1344C5.41006 13.3633 5.3 13.6719 5.3 13.9955C5.3 14.3191 5.41006 14.6276 5.63895 14.8565C5.86784 15.0854 6.17638 15.1955 6.5 15.1955C6.82362 15.1955 7.13216 15.0854 7.36105 14.8565C7.58994 14.6276 7.7 14.3191 7.7 13.9955Z" fill="%23C00000" stroke="%23C00000"/></svg>');
                width: 20px;
                height: 20px;
                border-width: thin;
                position: absolute;
                top: 15px;
                left: 20px;
                background-repeat: no-repeat;
              } */
            }
            input[type='date'] {
              position: relative;
              display: block;
              text-transform: uppercase;
              &::-webkit-calendar-picker-indicator {
                color: transparent;
                background: none;
                z-index: 9;
                position: absolute;
                top: 15px;
                left: 20px;
              }
              &::before {
                content: '';
                background: url('data:image/svg+xml,<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7 4.89548V5.39548H14.2H14.9C15.8139 5.39548 16.5 6.08163 16.5 6.99548V7.19548H3.5V6.99548C3.5 6.08163 4.18614 5.39548 5.1 5.39548H5.8H6.3V4.89548V4.19548C6.3 4.09911 6.32994 4.05765 6.34605 4.04154C6.36216 4.02543 6.40362 3.99548 6.5 3.99548C6.59638 3.99548 6.63784 4.02543 6.65395 4.04154C6.67006 4.05765 6.7 4.09911 6.7 4.19548V4.89548V5.39548H7.2H12.8H13.3V4.89548V4.19548C13.3 4.09911 13.3299 4.05765 13.3461 4.04154C13.3622 4.02543 13.4036 3.99548 13.5 3.99548C13.5964 3.99548 13.6378 4.02543 13.6539 4.04154C13.6701 4.05765 13.7 4.09911 13.7 4.19548V4.89548ZM5.1 16.9955C4.18614 16.9955 3.5 16.3093 3.5 15.3955V9.59548H16.5V15.3955C16.5 16.3093 15.8139 16.9955 14.9 16.9955H5.1ZM14.7 11.1955C14.7 10.8719 14.5899 10.5633 14.3611 10.3344C14.1322 10.1055 13.8236 9.99548 13.5 9.99548C13.1764 9.99548 12.8678 10.1055 12.6389 10.3344C12.4101 10.5633 12.3 10.8719 12.3 11.1955C12.3 11.5191 12.4101 11.8276 12.6389 12.0565C12.8678 12.2854 13.1764 12.3955 13.5 12.3955C13.8236 12.3955 14.1322 12.2854 14.3611 12.0565C14.5899 11.8276 14.7 11.5191 14.7 11.1955ZM14.7 13.9955C14.7 13.6719 14.5899 13.3633 14.3611 13.1344C14.1322 12.9055 13.8236 12.7955 13.5 12.7955C13.1764 12.7955 12.8678 12.9055 12.6389 13.1344C12.4101 13.3633 12.3 13.6719 12.3 13.9955C12.3 14.3191 12.4101 14.6276 12.6389 14.8565C12.8678 15.0854 13.1764 15.1955 13.5 15.1955C13.8236 15.1955 14.1322 15.0854 14.3611 14.8565C14.5899 14.6276 14.7 14.3191 14.7 13.9955ZM11.2 11.1955C11.2 10.8719 11.0899 10.5633 10.8611 10.3344C10.6322 10.1055 10.3236 9.99548 10 9.99548C9.67638 9.99548 9.36784 10.1055 9.13895 10.3344C8.91006 10.5633 8.8 10.8719 8.8 11.1955C8.8 11.5191 8.91006 11.8276 9.13895 12.0565C9.36784 12.2854 9.67638 12.3955 10 12.3955C10.3236 12.3955 10.6322 12.2854 10.8611 12.0565C11.0899 11.8276 11.2 11.5191 11.2 11.1955ZM11.2 13.9955C11.2 13.6719 11.0899 13.3633 10.8611 13.1344C10.6322 12.9055 10.3236 12.7955 10 12.7955C9.67638 12.7955 9.36784 12.9055 9.13895 13.1344C8.91006 13.3633 8.8 13.6719 8.8 13.9955C8.8 14.3191 8.91006 14.6276 9.13895 14.8565C9.36784 15.0854 9.67638 15.1955 10 15.1955C10.3236 15.1955 10.6322 15.0854 10.8611 14.8565C11.0899 14.6276 11.2 14.3191 11.2 13.9955ZM7.7 11.1955C7.7 10.8719 7.58994 10.5633 7.36105 10.3344C7.13216 10.1055 6.82362 9.99548 6.5 9.99548C6.17638 9.99548 5.86784 10.1055 5.63895 10.3344C5.41006 10.5633 5.3 10.8719 5.3 11.1955C5.3 11.5191 5.41006 11.8276 5.63895 12.0565C5.86784 12.2854 6.17638 12.3955 6.5 12.3955C6.82362 12.3955 7.13216 12.2854 7.36105 12.0565C7.58994 11.8276 7.7 11.5191 7.7 11.1955ZM7.7 13.9955C7.7 13.6719 7.58994 13.3633 7.36105 13.1344C7.13216 12.9055 6.82362 12.7955 6.5 12.7955C6.17638 12.7955 5.86784 12.9055 5.63895 13.1344C5.41006 13.3633 5.3 13.6719 5.3 13.9955C5.3 14.3191 5.41006 14.6276 5.63895 14.8565C5.86784 15.0854 6.17638 15.1955 6.5 15.1955C6.82362 15.1955 7.13216 15.0854 7.36105 14.8565C7.58994 14.6276 7.7 14.3191 7.7 13.9955Z" fill="%23C00000" stroke="%23C00000"/></svg>');
                width: 20px;
                height: 20px;
                position: absolute;
                top: 15px;
                left: 20px;
                background-repeat: no-repeat;
              }
            }
            .form-sign-icon {
              position: absolute;
              top: 15px;
              left: 20px;
              &.otp-mobile-icon {
                img {
                  width: auto;
                  height: 21px;
                }
              }
            }
            .phone-input {
              width: 100%;
              height: 50px;
              border: 1px solid rgba(0, 0, 0, 0.1);
              border-radius: 10px;
              padding: 0px;
              font-family: 'Mulish', serif;
              color: rgba(0, 0, 0, 0.3);
              font-size: 16px;
              line-height: 16px;
              box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
              input {
                border: none;
                background: transparent;
                box-shadow: none;
                outline: none;
                padding-left: 15px;
              }
              .PhoneInputCountry {
                padding: 10px;
                border: 1px solid rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                width: 100px;
                text-align: center;
                justify-content: center;
                .PhoneInputCountrySelectArrow {
                  border: none;
                  opacity: 1;
                  background-image: url('data:image/svg+xml,<svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.412893 2.72956L4.01989 6.11334C4.56303 6.62287 5.44041 6.62287 5.98354 6.11334L9.59054 2.72956C10.4679 1.90648 9.84122 0.495483 8.60175 0.495483H1.38776C0.148287 0.495483 -0.464485 1.90648 0.412893 2.72956Z" fill="black" fill-opacity="0.3"/></svg>');
                  background-size: contain;
                  width: 10px;
                  height: 7px;
                  transform: unset;
                }
                .PhoneInputCountryIcon {
                  width: 25px;
                  height: 26px;
                  border: none;
                  box-shadow: none;
                  background: none;
                  margin-right: 15px;
                }
              }
            }
          }
          .form-two-group {
            display: flex;
            margin: 0px -15px;
            @media (max-width: 767px) {
              display: block;
              margin: 0px;
            }
            &.before-none {
              .form-two-group-inner {
              .form_signup {
                  &::before {
                    content: none;
                  }
                }
              }
            }
            .form-two-group-inner {
              width: 50%;
              padding: 0px 15px;
              @media (max-width: 767px) {
                width: 100%;
                padding: 0px;
              }
              
              .form_signup {
                &::before {
                  content: '';
                  position: absolute;
                  right: 17px;
                  top: 21px;
                  background-image: url('data:image/svg+xml,<svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.412893 2.72956L4.01989 6.11334C4.56303 6.62287 5.44041 6.62287 5.98354 6.11334L9.59054 2.72956C10.4679 1.90648 9.84122 0.495483 8.60175 0.495483H1.38776C0.148287 0.495483 -0.464485 1.90648 0.412893 2.72956Z" fill="black" fill-opacity="0.3"/></svg>');
                  background-size: contain;
                  width: 10px;
                  height: 7px;
                }
              }
              select {
                -webkit-appearance: none;
                -moz-appearance: none;
                -o-appearance: none;
                appearance: none;
                background: none;
                width: 100%;
                height: 50px;
                border: 1px solid rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                padding: 10px 30px 10px 55px;
                font-family: 'Mulish', serif;
                color: rgba(0, 0, 0, 0.3);
                font-size: 16px;
                line-height: 16px;
                box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
                white-space: nowrap;
                text-overflow: ellipsis;
                @media (max-width: 767px) {
                  white-space: normal;
                  text-overflow: unset;
                }
              }
            }
          }
          .forgot-link {
            margin-bottom: 10px;
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;
            a {
              color: rgba(0, 0, 0, 0.5);
              font-size: 16px;
              line-height: 18px;
              font-weight: 400;
              font-family: 'Mulish', serif;
              &:hover {
                color: #c00000;
              }
            }
          }
          .bottom-auth-block {
            padding: 40px 50px 10px 50px;
            @media (max-width: 1499px) {
              padding: 20px 35px 5px 35px;
            }
            @media (max-width: 767px) {
              padding: 20px 0px 0px;
            }
            .common-btn-main {
              .btn-common-auth {
                width: 100%;
                border-color: #c00000;
                border-radius: 10px;
                background-color: #c00000;
                padding: 13px;
                font-size: 20px;
                line-height: 24px;
                font-family: 'Poppins', serif;
                font-weight: 600;
                color: #fff;
                &:hover {
                  background: transparent;
                  color: #c00000;
                }
                @media (max-width: 1199px) {
                  padding: 12px;
                  font-size: 18px;
                  line-height: 22px;
                }
              }
            }
            .sign-text-block {
              font-size: 19px;
              line-height: 20px;
              color: rgba(0, 0, 0, 0.5);
              font-family: 'Poppins', serif;
              text-align: center;
              padding-top: 40px;
              @media (max-width: 1499px) {
                font-size: 18px;
                line-height: 18px;
                padding-top: 25px;
              }
              a {
                color: #c00000;
                font-weight: 600;
                @media (max-width: 767px) {
                  display: block;
                  padding-top: 5px;
                }
              }
            }
          }
          .social-login-block {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 40px;
            @media (max-width: 1499px) {
              padding-top: 25px;
            }
            .social-login-block-inner {
              padding: 0px 8px;
              .social-login-btn {
                width: 100px;
                border-radius: 10px;
                border: 1px solid rgba(0, 0, 0, 0.1);
                box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
                display: flex;
                align-items: center;
                justify-content: center;
                height: 50px;
                background: transparent;
                outline: none;
                i {
                  font-size: 28px;
                  color: #1976d2;
                  margin-top: 5px;
                }
                @media (max-width: 1199px) {
                  width: 80px;
                  height: 50px;
                }
              }
            }
          }
          // .checkbox-block {
//   .checkbox-filter-block {
//     input {
//       padding: 0px;
//       height: initial;
//       width: initial;
//       margin-bottom: 0px;
//       display: none;
//       cursor: pointer;
//     }
//   }
// }

              label {
                position: relative;
                cursor: pointer;
                display: flex;
                align-items: center;
                span {
                  width: 20px;
                  height: 20px;
                  border: 1px solid rgba(0, 0, 0, 0.2);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 5px;
                  img {
                    display: none;
                    width: 14px;
                  }
                }
                .flex-block-check {
                  padding-left: 15px;
                  p {
                    color: rgba(0, 0, 0, 0.6);
                    font-size: 16px;
                    line-height: 18px;
                    font-weight: 500;
                    font-family: 'Mulish', serif;
                    @media (max-width: 1199px) {
                      font-size: 14px;
                      line-height: 18px;
                    }
                    a {
                      color: rgba(0, 0, 0, 0.6);
                      &:hover {
                        color: #c00000;
                      }
                    }
                  }
                }
              }
              input:checked + label span {
                background-color: #c00000;
                img {
                  display: block;
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const HeaderMain = styled.div`
  position: relative;
  .common-container {
    max-width: 1730px;
    margin: 0 auto;
    padding: 0px 15px;
  }
  .header {
    @media screen and (max-width: 1199px) {
      padding: 12px 0;
    }
    &.home-header {
      background: transparent;
      position: absolute;
      top: 0px;
      left: 0;
      right: 0px;
      @media screen and (max-width: 991px) {
        .desktop-menu-block {
          .main_head {
            flex-direction: column;
            .diff-mmobile-block {
              .btn-1 {
                padding: 12px !important;
                font-size: 18px;
                line-height: 18px;
                color: #fff;
                border-radius: 10px;
                background-color: #c00000;
                height: auto;
                text-align: center;
              }
            }
          }
        }
      }
    }
    .icon_mobile {
      @media screen and (max-width: 991px) {
        background-color: #c00;
        width: 40px;
        height: 40px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;
        right: 0px;
        top: 0px;
        span {
          width: 26px;
          height: 2px;
          display: block;
          background-color: #fff;
          margin-bottom: 5px;
          &:last-child {
            margin: 0px;
          }
        }
      }
    }
    .mobile_setting {
      .mobile-view-notifaction {
        display: none;
      }
      @media screen and (max-width: 991px) {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .notification-block-inner {
          position: absolute;
          display: block;
          right: 73px;
          top: 12px;
          .notification-block-inner-notifacation {
            position: relative;
            svg {
              fill: #fff;
              font-size: 22px;
            }
            .span-text {
              position: absolute;
              right: -6px;
              top: -5px;
              width: 15px;
              height: 15px;
              background-color: #c00000;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 600;
              font-size: 9px;
              line-height: 10px;
              color: #fff;
            }
          }
          .list-notification {
            position: absolute;
            right: 0px;
            background-color: #fff;
            border-radius: 10px;
            width: 250px;
            top: 30px;
            z-index: 9;
            /* padding: 10px; */
            text-align: left;
            ul {
              li {
                padding: 10px;
                border-bottom: 1px solid #c00000 !important;
                span {
                  font-size: 14px;
                  line-height: 16px;
                  color: #000;
                  font-weight: 400;
                }
              }
            }
            .notifation-last-btn {
              padding: 10px;
              a {
                padding: 12px;
                font-size: 16px;
                line-height: 16px;
                color: #fff;
                border-radius: 10px;
                background-color: #c00000;
                font-weight: 600;
                /* min-width: 100%; */
                width: 100%;
                display: block;
                text-align: center;
              }
            }
            .no-notifation-text {
              padding: 10px;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .desktop-menu-block {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    @media screen and (min-width: 992px) {
      .logo-mobile-view {
        display: none;
      }
    }
    @media screen and (max-width: 991px) {
      position: fixed !important;
      left: ${(props) => (props.isOpen ? "0px" : "-280px")}; /* Toggle left */
      top: 0px;
      height: 100% !important;
      right: 0px;
      justify-content: flex-start;
      align-items: flex-start;
      z-index: 999 !important;
      width: 280px;
      background-color: #fff;
      padding: 0px;
      flex-direction: column;
      box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
      overflow-y: auto;
      transition: all 0.5s;
      .close1 {
        display: none;
      }
      .logo-mobile-view {
        padding: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .main_head {
        width: 100%;
        flex-direction: column-reverse;
        text-align: left;
        align-items: flex-start;
        justify-content: flex-start;
        .menu_top {
          align-items: flex-start;
          text-align: left;
          display: block;
          padding-left: 0px;
          width: 100%;
          li {
            padding: 12px;
            border-bottom: 1px solid rgba(153, 153, 153, 0.2);
            width: 100%;
            .dropdown {
              a {
                position: relative;
                svg {
                  position: absolute;
                  right: 0px;
                  path {
                    fill: #333;
                  }
                }
              }
            }
          }
        }
        .right_menu {
          .hide_mobile {
            display: block;
          }
        }
      }
    }
    ul.menu_top {
      li {
        @media screen and (max-width: 1199px) {
          padding-left: 6px;
          padding-right: 6px;
        }
        @media screen and (max-width: 991px) {
          text-align: left;
          padding: 0px;
        }
        a {
          color: rgba(255, 255, 255, 0.8);
          font-family: "Poppins", sans-serif;
          @media screen and (max-width: 1199px) {
            font-size: 11px;
          }
          @media screen and (max-width: 991px) {
            color: rgba(51, 51, 51, 0.8);
            font-size: 15px;
            line-height: 20px;
            text-transform: capitalize;
          }
        }
      }
    }
    .right_menu {
      .dropdown_user {
        .dropdown {
          @media screen and (max-width: 991px) {
            .h_login {
              width: 100%;
              display: block;
              padding: 0px;
              svg {
                top: 6px;
              }
            }
          }
          .img_user {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            @media screen and (max-width: 1399px) {
              width: 40px;
              height: 40px;
            }
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              object-fit: cover;
              max-width: inherit;
            }
          }
          .dropdown-menu {
            padding: 0px;
            border-radius: 10px;
            /* top: 38px !important; */
            @media screen and (max-width: 991px) {
              position: relative !important;
              width: 100%;
              top: 0px !important;
              border: none;
              padding: 10px 0px;
              transform: unset !important;
              a {
                border: none !important;
                font-size: 14px;
                padding: 5px;
              }
            }
            a {
              padding: 15px 10px;
              color: rgba(0, 0, 0, 0.6);
              border-bottom: 1px solid rgba(153, 153, 153, 0.2);
              background: transparent;
              &:hover {
                color: #fb1417;
              }
              &:last-child {
                border: none;
              }
              @media screen and (max-width: 1399px) {
                padding: 10px 10px;
              }
            }
          }
        }
      }
      &.diff-mmobile-block {
        li {
          .btn-1 {
            &:hover {
              background-color: #c00;
              opacity: 0.8;
            }
          }
        }
      }
    }
    .notification-block-inner {
      position: relative;
      @media screen and (max-width: 991px) {
        display: none;
      }
      .notification-block-inner-notifacation {
        position: relative;

        svg {
          fill: #fff;
          font-size: 22px;
        }
        .span-text {
          position: absolute;
          right: -6px;
          top: -5px;
          width: 15px;
          height: 15px;
          background-color: #c00000;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 10px;
          color: #fff;
        }
      }
      .list-notification {
        position: absolute;
        right: 0px;
        background-color: #fff;
        border-radius: 10px;
        width: 250px;
        top: 30px;
        z-index: 9;
        box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.05);
        /* padding: 10px; */
        text-align: left;
        ul {
          li {
            padding: 10px;
            border-bottom: 1px solid #c00000 !important;
            span {
              font-size: 14px;
              line-height: 16px;
              color: #000;
              font-weight: 400;
            }
          }
        }
        .notifation-last-btn {
          padding: 10px;
          a {
            padding: 12px;
            font-size: 16px;
            line-height: 16px;
            color: #fff;
            border-radius: 10px;
            background-color: #c00000;
            font-weight: 600;
            /* min-width: 100%; */
            width: 100%;
            display: block;
            text-align: center;
          }
        }
      }
    }
  }
`;
export const FooterMain = styled.div`
  .footer {
    background: rgba(0, 0, 0, 0.8);
    padding: 60px 0px;
    font-family: "Poppins", sans-serif;
    @media screen and (max-width: 1399px) {
      padding: 40px 0px;
    }
    @media screen and (max-width: 991px) {
      padding: 40px 0px 20px;
    }
    .title-footer {
      font-size: 26px;
      line-height: 32px;
      color: #fff;
      font-weight: 600;
      position: relative;
      margin-bottom: 50px;
      @media screen and (max-width: 1399px) {
        font-size: 20px;
        line-height: 26px;
        margin-bottom: 30px;
      }
      @media screen and (max-width: 991px) {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 30px;
      }
      &::after {
        content: "";
        position: absolute;
        bottom: -15px;
        left: 0px;
        width: 80px;
        height: 1px;
        background-color: #c00000;
      }
    }
    .row {
      align-items: start;
      justify-content: start;
      /* @media screen and (max-width: 1199px) {
        align-items: center;
        justify-content: center;
      } */
    }
    .bx_footer {
      @media screen and (max-width: 1199px) {
        padding-right: 0px;
        margin-bottom: 30px;
        .cards {
          margin-top: 30px;
        }
      }
      @media screen and (max-width: 991px) {
        .menu_footer {
          margin-bottom: 15px;
        }
      }
      .footer_logo {
        margin-bottom: 70px;
        @media screen and (max-width: 1399px) {
          margin-bottom: 40px;
        }
      }
    }
    .cards {
      list-style: none;
      li {
        padding: 0 12px 0px 0px;
        &::after {
          content: none;
        }
      }
    }
    .icon-contact-details {
      ul {
        li {
          margin-bottom: 22px;
          .link-f-last {
            position: relative;
            padding-left: 30px;
            svg {
              position: absolute;
              left: 0px;
              top: 2px;
            }
            span {
              font-size: 14px;
              line-height: 20px;
              font-weight: 500;
              color: #fff;
              @media screen and (max-width: 1399px) {
                font-size: 11px;
                line-height: 18px;
              }
            }
          }
        }
      }
    }
  }
`;

export const FooterBottomInner = styled.div`
  position: relative;
  margin-top: 20px;
  font-family: "Poppins", sans-serif;
  text-align: center;
  @media screen and (max-width: 1199px) {
    margin-top: 10px;
  }
  .f-bottom {
    padding: 25px;
    background-color: #c00000;
    @media screen and (max-width: 1199px) {
      padding: 15px;
    }
    p {
      font-size: 18px;
      line-height: 18px;
      color: #fff;
      font-weight: 600;
      @media screen and (max-width: 1199px) {
        font-size: 14px;
        line-height: 18px;
      }
    }
    a {
      color: #fff;
      font-weight: 600;
    }
  }
`;

export const CommonPageInner = styled.div`
  position: relative;
  font-family: "Poppins", sans-serif;

  ul.breadcrumb.main {
    li {
      a {
        font-size: 14px;
        @media screen and (max-width: 767px) {
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }
  .common-banner-block {
    position: relative;
    .main-banner {
      width: 100%;
      height: 210px;
      @media screen and (max-width: 1399px) {
        height: 180px;
      }
      @media screen and (max-width: 767px) {
        height: 160px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .common-banner-block-inner {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      left: 0px;
      right: 0px;
      @media screen and (max-width: 767px) {
        text-align: center;
        padding: 0px 5px;
      }
      h1 {
        font-weight: 600;
        font-size: 55px;
        line-height: 55px;
        color: #fff;
        @media screen and (max-width: 1399px) {
          font-size: 45px;
          line-height: 50px;
        }
        @media screen and (max-width: 1199px) {
          font-size: 35px;
          line-height: 45px;
        }
        @media screen and (max-width: 991px) {
          font-size: 28px;
          line-height: 38px;
        }
        @media screen and (max-width: 991px) {
          font-size: 24px;
          line-height: 34px;
        }
        @media screen and (max-width: 767px) {
          font-size: 20px;
          line-height: 30px;
        }
      }

      .common-inner-ttile-block {
        color: #fff;
        margin-top: 15px;
        font-size: 20px;
        line-height: 28px;
        @media screen and (max-width: 1399px) {
          font-size: 18px;
          line-height: 26px;
        }
        @media screen and (max-width: 991px) {
          margin-top: 5px;
          font-size: 13px;
          line-height: 18px;
        }
        @media screen and (max-width: 767px) {
          font-size: 12px;
        }
      }
      p {
        color: #fff;
        margin-top: 15px;
        font-size: 18px;
        line-height: 24px;
        @media screen and (max-width: 1399px) {
          font-size: 16px;
          line-height: 22px;
        }
        @media screen and (max-width: 991px) {
          margin-top: 5px;
          font-size: 13px;
          line-height: 18px;
        }
        @media screen and (max-width: 767px) {
          font-size: 12px;
        }
      }
      .theme-diff-btn-block {
        margin-top: 15px;
        padding: 12px;
        font-size: 20px;
        line-height: 20px;
        color: #fff;
        border-radius: 10px;
        background-color: #c00000;
        font-weight: 700;
        min-width: 200px;
        /* &:hover {
          background-color: #000;
        } */
        @media screen and (max-width: 767px) {
          margin-top: 5px;
          padding: 10px;
          font-size: 14px;
          line-height: 14px;
          min-width: 160px;
        }
      }
    }
  }
`;

export const CommonPageData = styled.div`
  position: relative;
  font-family: "Poppins", sans-serif;
  .common-box-bg {
    background-color: #fff;
    box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.1);
  }

  .text-center-mobile {
    @media screen and (max-width: 991px) {
      text-align: center !important;
      .theme-btn-link {
      }
    }
  }
  .common-padding-block {
    padding: 70px 0px;
    @media screen and (max-width: 1399px) {
      padding: 50px 0px;
    }
    @media screen and (max-width: 991px) {
      padding: 40px 0px;
    }
    @media screen and (max-width: 767px) {
      padding: 30px 0px;
    }
  }
  .common-banner-block {
    position: relative;
    &.height-diff-assement {
      .main-banner {
        @media screen and (max-width: 767px) {
          height: 90px;
        }
      }
    }
    .main-banner {
      width: 100%;
      height: 210px;
      @media screen and (max-width: 1399px) {
        height: 180px;
      }
      @media screen and (max-width: 1199px) {
        height: 140px;
      }
      @media screen and (max-width: 1199px) {
        height: 110px;
      }
      @media screen and (max-width: 767px) {
        height: 75px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .common-banner-block-inner {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      left: 0px;
      right: 0px;
      @media screen and (max-width: 767px) {
        text-align: center;
        padding: 0px 5px;
      }
      h1 {
        font-weight: 600;
        font-size: 55px;
        line-height: 55px;
        color: #fff;
        @media screen and (max-width: 1399px) {
          font-size: 45px;
          line-height: 50px;
        }
        @media screen and (max-width: 1199px) {
          font-size: 35px;
          line-height: 45px;
        }
        @media screen and (max-width: 991px) {
          font-size: 28px;
          line-height: 38px;
        }
        @media screen and (max-width: 991px) {
          font-size: 24px;
          line-height: 34px;
        }
        @media screen and (max-width: 767px) {
          font-size: 22px;
          line-height: 32px;
        }
      }
      .common-banner-block-inner-center {
        text-align: center;
        span {
          color: #fff;
          margin-top: 15px;
          font-size: 20px;
          line-height: 28px;
          display: block;
          @media screen and (max-width: 1399px) {
            font-size: 18px;
            line-height: 26px;
          }
          @media screen and (max-width: 991px) {
            margin-top: 5px;
            font-size: 13px;
            line-height: 18px;
          }
          @media screen and (max-width: 767px) {
            font-size: 12px;
          }
        }
      }
      .common-inner-ttile-block {
        color: #fff;
        margin-top: 15px;
        font-size: 22px;
        line-height: 30px;
        @media screen and (max-width: 1399px) {
          font-size: 18px;
          line-height: 26px;
        }
        @media screen and (max-width: 991px) {
          margin-top: 5px;
          font-size: 13px;
          line-height: 18px;
        }
        @media screen and (max-width: 767px) {
          font-size: 12px;
        }
      }
      p {
        color: #fff;
        margin-top: 15px;
        font-size: 18px;
        line-height: 24px;
        @media screen and (max-width: 1399px) {
          font-size: 16px;
          line-height: 22px;
        }
        @media screen and (max-width: 1199px) {
          font-size: 14px;
          line-height: 20px;
        }
        @media screen and (max-width: 991px) {
          margin-top: 5px;
          font-size: 13px;
          line-height: 18px;
        }
        @media screen and (max-width: 767px) {
          font-size: 12px;
        }
        &.assesment-block-disc {
          text-align: center;
          margin-top: 15px;
          font-size: 20px;
          line-height: 30px;
        }
      }

      .theme-diff-btn-block {
        margin-top: 15px;
        padding: 12px;
        font-size: 20px;
        line-height: 20px;
        color: #fff;
        border-radius: 10px;
        background-color: #c00000;
        font-weight: 700;
        min-width: 200px;
        /* &:hover {
          background-color: #000;
        } */
        @media screen and (max-width: 767px) {
          margin-top: 5px;
          padding: 10px;
          font-size: 14px;
          line-height: 14px;
          min-width: 160px;
        }
      }
    }
  }
  .theme-common-btn {
    padding: 12px 23px;
    font-size: 20px;
    line-height: 20px;
    color: #fff;
    border-radius: 10px;
    background-color: #000;
    font-weight: 700;
    &:hover {
      background-color: #c00000;
    }
    @media screen and (max-width: 991px) {
      padding: 10px 15px;
      font-size: 18px;
      line-height: 18px;
    }
    @media screen and (max-width: 767px) {
      padding: 10px 15px;
      font-size: 14px;
      line-height: 14px;
    }
  }
  ul.breadcrumb.main {
    li {
      @media screen and (max-width: 767px) {
        padding-right: 5px !important;
        padding-left: 5px !important;
      }
      a {
        font-size: 14px;
        @media screen and (max-width: 767px) {
          font-size: 12px;
          line-height: 18px;
        }
        @media screen and (max-width: 500px) {
          font-size: 10px;
          line-height: 18px;
        }
      }
    }
  }

  .faq-section-block {
    padding: 50px 0px;
    .search-block-custom {
      padding: 0px;
      button {
        top: 12px;
        left: 20px;
      }
    }
    .faq-wrapper {
      padding-top: 50px;
      .accordion {
        padding: 0px;
        .accordion-tab {
          margin-bottom: 30px;
          border: none !important;
          .faq-heading {
            padding: 20px;
            background-color: #fff;
            box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
            border-radius: 20px;
            font-family: "Mulish", serif;
          }
          .contents {
            color: rgba(0, 0, 0, 0.4);
            font-size: 18px;
            line-height: 28px;
          }
        }
      }
    }
  }

  .change-block {
    position: relative;
    padding: 70px 0px;
    @media screen and (max-width: 1399px) {
      padding: 50px 0px;
    }
    @media screen and (max-width: 1199px) {
      padding: 30px 0px;
    }
    .top-block {
      padding-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title-inner-block {
        span {
          text-transform: capitalize;
        }
      }
      &.diff-text-center {
        justify-content: center;
      }
    }
    .video-block-play {
      max-width: 750px;
      margin: 0 auto;
      .video-block {
        position: relative;
        padding: 20px;
        background-color: #fff;
        box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
        border-radius: 20px;
        font-family: "Mulish", serif;
        height: 400px;
        > img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        button {
          background-color: transparent;
          border: none;
          outline: none;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .release-block {
        padding: 50px 0px 0px;
        text-align: center;
        p {
          color: #000;
          font-size: 20px;
          line-height: 30px;
          margin-bottom: 25px;
          font-weight: 600;
        }
        button {
          background: transparent;
          border: none;
          outline: none;
          box-shadow: none;
          font-size: 26px;
          line-height: 26px;
          color: #0342b6;
          text-decoration: underline;
        }
      }
    }

    .middle-text-block {
      text-align: center;
      p {
        font-size: 24px;
        line-height: 36px;
      }
    }
    .change-level-block {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px -15px 0px;
      border-bottom: 2px solid #000;
      padding-bottom: 50px;
      .change-level-block-inner {
        width: 25%;
        padding: 0px 15px;
        &:nth-child(2) {
          .box-changes {
            border-color: #0342b6;
            h3 {
              color: #0342b6;
            }
          }
        }
        &:nth-child(3) {
          .box-changes {
            border-color: #c00000;
            h3 {
              color: #c00000;
            }
          }
        }
        .box-changes {
          padding: 20px;
          background-color: #fff;
          box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
          border-radius: 20px;
          font-family: "Mulish", serif;
          border: 1px solid #00a746;
          text-align: center;
          .img-change-block {
            width: 100%;
            height: 200px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
            video {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          h3 {
            font-size: 30px;
            line-height: 36px;
            color: #00a746;
            font-weight: 600;
            margin-bottom: 10px;
            text-align: left;
            margin-bottom: 10px;
          }
          p {
            color: #000;
            font-size: 20px;
            line-height: 30px;
            margin-top: 15px;
          }
        }
      }
    }
    .equipment-block {
      padding: 50px 0px;
      .equipment-block-inner {
        width: 70%;
        margin: 0 auto;
        .equipment-block-flex {
          padding: 10px;
          background-color: #fff;
          box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
          border-radius: 20px;
          font-family: "Mulish", serif;
          border: 1px solid #000;
          display: flex;
          align-items: center;
          margin-bottom: 30px;
          .img-equipment {
            width: 200px;
            height: 150px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          p {
            color: #000;
            font-size: 20px;
            line-height: 30px;
            padding-left: 15px;
          }
        }
      }
    }
  }
  .welcome_003 {
    padding: 70px 0px;
    @media screen and (max-width: 1199px) {
      padding: 40px 0px;
    }
    @media screen and (max-width: 991px) {
      padding: 30px 0px;
    }
    h4 {
      font-size: 30px;
      line-height: 30px;
      margin-bottom: 30px;
      font-weight: 600;
      @media screen and (max-width: 1399px) {
        font-size: 24px;
        line-height: 26px;
        margin-bottom: 15px;
      }
      @media screen and (max-width: 991px) {
        font-size: 20px;
        line-height: 24px;
        margin-bottom: 10px;
      }
      @media screen and (max-width: 767px) {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 5px;
      }
    }
    .ssa {
      &.box_video {
        width: 100%;
        /* height: 270px; */
        height: auto;
        border-radius: 20px;
        padding: 10px;
        margin-bottom: 50px;
        @media screen and (max-width: 1399px) {
          margin-bottom: 30px;
        }
        @media screen and (max-width: 991px) {
          margin-bottom: 30px;
          /* height: 230px; */
          height: auto;
          padding: 5px;
          border-radius: 10px;
        }
        @media screen and (max-width: 767px) {
          height: auto;
        }
        video {
          width: 100%;
          height: 100%;
          border-radius: 20px;
          object-fit: fill;
          @media screen and (max-width: 991px) {
            border-radius: 10px;
          }
        }
      }
    }
  }
  .assestmentgrid_001 {
    padding: 0px 0px 30px;
    .box_week {
      background: transparent;
      &.carousel {
        @media screen and (max-width: 767px) {
          .carousel-control-prev {
            left: 15px;
            top: 64px;
            width: 22px;
            height: 22px;
            background: #000;
            display: flex;
            opacity: 1;
            border-radius: 50%;
            span {
              width: 15px;
              height: 15px;
            }
          }
          .carousel-control-next {
            left: auto;
            right: 15px;
            top: 64px;
            width: 22px;
            height: 22px;
            background: #000;
            display: flex;
            border-radius: 50%;
            opacity: 1;
            span {
              width: 15px;
              height: 15px;
            }
          }
        }
      }
      .carousel-inner {
        @media screen and (max-width: 1480px) {
          padding: 10px;
        }
        @media screen and (max-width: 767px) {
          padding: 0px;
          /* .carousel-item {
            display: block !important;
          } */
        }
        h6 {
          background-color: #000;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          @media screen and (max-width: 1199px) {
            height: 60px;
            font-size: 14px;
            padding-right: 40px;
          }
          @media screen and (max-width: 767px) {
            height: 40px;
            font-size: 10px;
            padding-right: 0px;
          }
        }
        .box_date {
          background: transparent;
          padding: 0px 0px 0px 20px;
          @media screen and (max-width: 767px) {
            padding: 0px 0px 0px 5px;
          }
          .date_week {
            border-radius: 10px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            li {
              p {
                margin: 0px;
                padding: 29px 0;
                border-radius: 10px;
                color: rgba(0, 0, 0, 0.4);
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 700;
                width: 100%;
                &.active {
                  color: #fff;
                  background-color: #c00000;
                }
                @media screen and (max-width: 1199px) {
                  padding: 21px 0;
                }
                @media screen and (max-width: 767px) {
                  padding: 11px 0;
                  font-size: 9px;
                }
              }
            }
          }
        }
      }
    }
  }
  .mt-circuit-block {
    padding-top: 40px;
    padding-bottom: 40px;
    @media screen and (max-width: 767px) {
      padding-top: 25px;
    }
    .title-inner-block {
      padding-bottom: 30px;
      font-size: 30px;
      line-height: 30px;
      color: #000;
      font-weight: 600;
      span {
        color: #c00000;
      }
      @media screen and (max-width: 1399px) {
        padding-bottom: 20px;
        font-size: 26px;
        line-height: 30px;
      }
      @media screen and (max-width: 1199px) {
        padding-bottom: 15px;
        font-size: 24px;
        line-height: 28px;
      }
      @media screen and (max-width: 991px) {
        padding-bottom: 15px;
        font-size: 22px;
        line-height: 26px;
      }
      @media screen and (max-width: 767px) {
        padding-bottom: 15px;
        font-size: 18px;
        line-height: 24px;
      }
    }
    .button-group-circuit {
      margin-bottom: 30px;
    }
  }
  .common-btn-all-front {
    margin-top: 15px;
    padding: 14px 10px;
    font-size: 20px;
    line-height: 20px;
    color: #fff;
    border-radius: 10px;
    background-color: #c00000;
    font-weight: 700;
    min-width: 230px;
    border-color: transparent;
    margin: 0px;
    &:hover {
      background-color: #000;
    }
    &.black-btn {
      background-color: #000;
      &:hover {
        background-color: #c00000;
      }
    }
    &.min-auto-btn {
      min-width: auto;
      padding: 14px 30px;
    }
    @media screen and (max-width: 991px) {
      padding: 10px 5px;
      font-size: 14px;
      line-height: 14px;
      min-width: 160px;
    }
    @media screen and (max-width: 991px) {
      padding: 10px 5px;
      font-size: 12px;
      line-height: 12px;
      min-width: 140px;
    }
  }
  .common-circuits-tabs {
    .left-right-text-block {
      position: absolute;
      width: 100%;
      font-size: 9px;
      left: 30px;
      top: 20px;
      @media screen and (max-width: 991px) {
        left: 25px;
        top: 10px;
      }
      @media screen and (max-width: 767px) {
        left: 10px;
        top: 8px;
      }
      p {
        position: unset !important;
        font-size: 14px;
        @media screen and (max-width: 991px) {
          font-size: 13px;
        }
        @media screen and (max-width: 767px) {
          font-size: 10px;
        }
      }
    }
    .nav-item {
      @media screen and (max-width: 767px) {
        padding: 0px 5px !important;
      }
      .nav-link {
        padding: 20px;
        background-color: #fff;
        box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
        border-radius: 20px;
        font-family: "Mulish", serif;
        border: 2px solid transparent;
        @media screen and (max-width: 991px) {
          padding: 10px;
          border-radius: 10px !important;
        }
        @media screen and (max-width: 767px) {
          padding: 5px;
        }
        &.active {
          border-color: #c00000;
          .title_box {
            h6 {
              color: #c00000;
            }
          }
        }
        .box_levelimg1 {
          width: 100%;
          height: 219px;
          margin-bottom: 25px;
          border: none;
          @media screen and (max-width: 991px) {
            height: 180px;
            margin-bottom: 15px;
            .info_icon {
              top: 5px;
              right: 15px;
              .info_icon_ic {
                width: 15px !important;
                height: 15px !important;
              }
            }
          }
          @media screen and (max-width: 767px) {
            height: 130px;
            margin-bottom: 10px;
          }
          @media screen and (max-width: 767px) {
            height: 130px;
            margin-bottom: 10px;
          }
          @media screen and (max-width: 767px) {
            height: 100px;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .title_box {
          h6 {
            font-family: "Mulish", serif;
            font-size: 14px;
            color: #000;
            padding: 0px;
            text-align: center;
            @media screen and (max-width: 991px) {
              font-size: 12px !important;
            }
          }
        }
      }
    }
  }
  .title-inner-block {
    padding-bottom: 30px;
    font-size: 30px;
    line-height: 30px;
    color: #000;
    font-weight: 600;
    span {
      color: #c00000;
    }
    @media screen and (max-width: 1399px) {
      padding-bottom: 20px;
      font-size: 26px;
      line-height: 30px;
    }
    @media screen and (max-width: 1199px) {
      padding-bottom: 15px;
      font-size: 24px;
      line-height: 28px;
    }
    @media screen and (max-width: 991px) {
      padding-bottom: 15px;
      font-size: 22px;
      line-height: 26px;
    }
    @media screen and (max-width: 767px) {
      padding-bottom: 15px;
      font-size: 18px;
      line-height: 24px;
    }
  }
  .assestmentd1_001 {
    background: transparent;
    &.program-box-height {
      @media screen and (max-width: 767px) {
        min-height: auto;
      }
    }
  }
  .assestmentd1_001 {
    .programs {
      .program-card {
        padding: 0px;
        border: none;
        width: 100%;
        a {
          width: 600px;
          padding: 30px 13px;
          color: #fff;
          font-weight: 700;
          border-radius: 10px;
          background-color: #000;
          font-size: 24px;
          line-height: 28px;
          display: block;
          margin: 0 auto;
          display: table;
          &:hover {
            background-color: #c00000;
          }
          @media screen and (max-width: 1399px) {
            width: 400px;
            padding: 20px 13px;
            font-size: 20px;
            line-height: 24px;
          }
          @media screen and (max-width: 1199px) {
            width: 300px;
            padding: 15px 13px;
            font-size: 18px;
            line-height: 22px;
          }
          @media screen and (max-width: 991px) {
            width: 250px;
            padding: 15px 13px;
            font-size: 16px;
            line-height: 20px;
          }
        }
      }
    }
  }
  .videos {
    .videos_headings {
      background: transparent;
      padding: 0px;
      .detail_span {
        padding-bottom: 30px;
        font-size: 30px;
        line-height: 30px;
        color: #000;
        font-weight: 600;
        background: transparent;
        @media screen and (max-width: 1399px) {
          font-size: 26px;
          line-height: 32px;
          padding-bottom: 25px;
        }
        @media screen and (max-width: 1199px) {
          font-size: 24px;
          line-height: 32px;
          padding-bottom: 20px;
        }
        @media screen and (max-width: 991px) {
          font-size: 20px;
          line-height: 26px;
          padding-bottom: 15px;
        }
        @media screen and (max-width: 767px) {
          font-size: 18px;
          line-height: 26px;
        }
        span {
          color: #c00000;
        }
      }
    }
    .test_videobox-education {
      border: 1px solid #000;
      box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
      background-color: #fff;
      padding: 10px;
      height: 220px;
      border-radius: 10px;
      margin-bottom: 30px;
      @media screen and (max-width: 767px) {
        height: auto;
        margin-bottom: 15px;
      }
      &.height-diff-block {
        height: 190px;
        .check_test {
          margin: 0px;
          padding: 0px !important;
        }
        .video-player {
          height: 100%;
        }
      }
      video {
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: 10px;
        max-height: inherit;
        border: none;
      }
    }
    .second-video-block {
      padding-bottom: 70px;
      @media screen and (max-width: 1399px) {
        padding-bottom: 50px;
      }
      @media screen and (max-width: 1199px) {
        padding-bottom: 40px;
      }
      .product-box {
        padding: 20px;
        background-color: #fff;
        box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
        border-radius: 20px;
        font-family: "Mulish", serif;
        border: 2px solid transparent;
        @media screen and (max-width: 1199px) {
          padding: 15px;
          max-height: none;
          height: auto;
          img.product-img {
            height: auto;
            max-height: none;
          }
        }
        @media screen and (max-width: 991px) {
          padding: 10px;
        }
        .mx-auto {
          width: 100%;
          height: 219px;
          margin-bottom: 25px;
          border: none;
          @media screen and (max-width: 1199px) {
            height: auto;
          }
        }
        .title-block-edu {
          h3 {
            font-family: "Mulish", serif;
            font-size: 18px;
            color: #000;
            padding: 10px 0px 0px;
            font-weight: 600;
            text-align: center;
            @media screen and (max-width: 1199px) {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .list-view-block {
    @media screen and (max-width: 991px) {
      padding: 0px 0px 0px 15px;
      width: 100%;
      justify-content: center;
      .row.d-flex.justify-content-center.mb-4 {
        margin-left: 0px !important;
      }
      .info_icon {
        top: 5px;
        right: 20px;
        .btn_primary_data {
          .info_icon_ic {
            width: 15px !important;
            height: 15px !important;
          }
        }
      }
    }
    .nav-link {
      padding: 20px;
      background-color: #fff;
      box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      font-family: "Mulish", serif;
      border: 1px solid transparent !important;
      @media screen and (max-width: 1199px) {
        padding: 10px;
        border-radius: 10px;
      }
      &.active,
      &:hover {
        border: 1px solid #c00000 !important;
        .box-circuit {
          .detail_text {
            h6 {
              color: #c00000;
            }
          }
        }
      }
      .box-circuit {
        .detail_all {
          width: 100%;
          height: 100px;
          padding: 0px;
          border: none;
          > img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .detail_text {
          h6 {
            font-size: 20px;
            line-height: 24px;
            font-weight: 600;
            color: #000;
            margin-bottom: 10px;
            @media screen and (max-width: 991px) {
              font-size: 14px;
              line-height: 20px;
            }
          }
          .detail_hour {
            margin-left: 0px !important;
            p {
              font-weight: normal;
              color: rgba(0, 0, 0, 0.4);
              .info {
                color: #000;
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
  .common-box-bg-all {
    padding: 20px;
    background-color: #fff;
    box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    font-family: "Mulish", serif;
    &.common-box-bg-all-one-screen {
      padding: 10px;
      .video-player {
        .detail-play-button {
          top: 20%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
  .theme-common-btn-small {
    padding: 12px 23px;
    font-size: 20px;
    line-height: 20px;
    color: #fff;
    border-radius: 10px;
    background-color: #c00000;
    font-weight: 700;
    font-family: "Poppins", serif;
    &:hover {
      background-color: #000;
    }
    &.black-btn {
      background-color: #000;
      &:hover {
        background-color: #c00000;
      }
    }
    &.input-btn {
      border: none;
    }
  }
  .theme-common-btn-big {
    padding: 14px 10px;
    font-size: 20px;
    line-height: 20px;
    color: #fff;
    border-radius: 10px;
    background-color: #c00000;
    font-weight: 700;
    min-width: 230px;
    border-color: transparent;
    margin: 0px;
    font-family: "Poppins", serif;
    text-align: center;
    &:hover {
      background-color: #000;
    }
    &.black-btn {
      background-color: #000;
      &:hover {
        background-color: #c00000;
      }
    }
    &.margin-auto-btn {
      margin: 0 auto;
    }
    @media screen and (max-width: 1399px) {
      padding: 11px 10px;
      font-size: 14px;
      min-width: 200px;
    }
    @media screen and (max-width: 1199px) {
      padding: 10px 10px;
      font-size: 14px;
      min-width: 180px;
    }
    @media screen and (max-width: 991px) {
      padding: 10px;
      font-size: 14px;
      min-width: 130px;
    }
  }
  .test-new {
    padding: 20px 0px 70px;
    .text-flex-goal {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
      h3 {
        text-decoration: none;
        padding-bottom: 30px;
        font-size: 30px;
        line-height: 30px;
        color: #000;
        margin: 0px;
        font-weight: 600;
        span {
          color: #c00000;
        }
      }
    }
    p {
      margin-bottom: 25px;
      margin-top: 0px;
      font-family: "Mulish", serif;
      font-size: 14px;
      &.mb-0 {
        margin-bottom: 0px;
      }
    }
    .list_pain1 {
      font-family: "Poppins", serif;
      margin-bottom: 25px;
      li {
        margin-bottom: 25px;
        position: relative;
        padding-left: 45px;
        img {
          position: absolute;
          left: 0px;
          top: -4px;
        }
        span {
          margin: 0px;
          font-size: 22px;
          line-height: 26px;
          color: #000;
          font-weight: 500;
        }
      }
    }
  }
  .test-block-videos {
    padding: 50px 0px;
    .message-info {
      border: 1px solid #c2351c;
      color: #c2351c;
      padding: 10px 15px;
      border-radius: 10px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      max-width: 600px;
      margin: 10px auto;
    }
    .test_videobox {
      input {
        display: none;
      }
      // .checkbox-block {
      //   .checkbox-filter-block {
      //     input {
      //       padding: 0px;
      //       height: initial;
      //       width: initial;
      //       margin-bottom: 0px;
      //       display: none;
      //       cursor: pointer;
      //     }
      //   }
      // }

      .check_test {
        label {
          border: none;
          padding: 0px;
          border-radius: 0px;
          .check-block-videso-block {
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;
            margin-bottom: 15px;
            position: relative;
            &::after {
              content: none;
              position: absolute;
              right: -4px;
              top: 0px;
              background-image: url('data:image/svg+xml,<svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 21" width="27" height="21"><defs><image width="27" height="21" id="img1" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAVCAMAAACAAGUXAAAAAXNSR0IB2cksfwAAAZVQTFRFAgICAAAA/wAAqhke8B8o/yEr5SIqBAQEAAAAuhgf/yEp8Rsi+x0l1iAmAAAAAQEBSSQk9iAo8Rsi6Rsh/R4myxwkGRkZFxcXihYd/yEq5xsi6xsh/B8nsBYfAAAApRgc/h8n6Bsi7Bsi+h4lyR0mtCMt/R4m6Rsi7Boi9h0k5CEoAAAAcxkZ/h8m6Rwi7Bsh8xwj6hsnQEBA/yAp6Bsi7Bsi7Roh4yUsYhQU/yEt6Bsh7Bsi6Boh9SUtuxog/CEq1hwk7yQt6Boi7Bsi/yIq7ycw8hsi7Bsi6xsi9R0l1Roi6SMq8Rkg7Boh+x4mhxYeAgICBwcHzRsj/B0l/h8nXRcXuyQo9hsi8hsi5SEoDw8Pxhoj6xoi6hoi4B4lVRUV/x0m6xwj6Roh8SAoEBAQzxkf9Rwk7Bsi/R8m/yEq6xsi/yEp6iEq6Roh5xsh/x8n6Bsh9B0kwBoh6xsh6hoh5iAnDQ0Nvh4m7xoh/CAp6xsi6xoh2hwlwhge7Rsh6Roi/yAo1h0kRhcX9hwj7x8q9CUsohIZ9dR17AAAAId0Uk5TAAAAWdf/pAAEa/37/1gBAAfl/fb/QAAAFf/59/86Aw/V9/n/PROs7/r/TQIY8Pf8/nAE//j8+60N+Pj++t5h9WTN+v//h/37+/9hi/v8/yIBAGL//wtA//x0ADr6+rgM//n61gBb/v3/+v//vvn5+vn/Rfv7wgBe/fj9+1p+/Pr/aQv/09hHS5UQ6wAAAV1JREFUeJxl0T1Iw0AUB/D3F/qBeqkIKggRhEIhjoq2QqGDDg6iuHV2UHRwURBcHNx0FhR0cHFx0E2HDoKDtVi/IINYQYI4dBBzDk1V4uXy0Za84T7y4+7eewHBBpFNToC8gBM/CPZOROtiiFlxaYSEqRCZRErNooSYibVJsYg3zvXApqqY+yTBcG6m1hiQUjcobElJ3waFTHPvq3AKWcy1G+Yb42NFzeAy+bRDVx4Jy6Lyl7oUe8ZzwFdXQTX8DkwCvxHgTSeWxWc38KLPnM2eSpvD3SBFOqHzNF6jKh518TV/LE2Zvs58UD9uR4DnFA7lY/MH7nvauLjHHN5bLI2eT+3GLNE+0zfGl1GODwFPyXacOHk0jFRjKX4vlrUMdmR+Nta2/drVPEpi+d5RdtNXTL8+8Vf4Ooq1XLX3yK2s2YitoDABbHo1t9rq/gIeLsjrlY0mI9rCRtCq4Nw/KoppOHc6By0AAAAASUVORK5CYII="/></defs><style></style><use id="Background" href="%23img1" x="0" y="0"/></svg>');
              width: 27px;
              height: 21px;
            }
          }
        }
        .vids {
          .video_testcontent {
            h6 {
              font-family: "Mulish", serif;
              font-size: 14px;
              color: #000;
              padding: 0px;
              text-align: center;
              margin-top: 15px;
            }
          }
        }
      }
    }
    .block-btn-test {
      /* display: flex;
      align-items: center;
      justify-content: space-evenly; */
      margin-top: 25px;
      .test_btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      @media screen and (max-width: 767px) {
        .test_btn {
          flex-direction: column;
        }
      }
    }
    .top-video-box {
      padding: 10px;
      width: 50%;
      margin: 0 auto 50px;
      display: table;
      box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
      @media screen and (max-width: 767px) {
        margin: 0 auto 25px;
      }
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 10px;
      }
    }
    .mb-none-text-inner {
      margin-bottom: 30px;
      height: auto;
    }
    .videos-block-left {
      display: flex;
      gap: 30px;
      @media screen and (max-width: 767px) {
        display: block;
      }
      .top-video-box {
        @media screen and (max-width: 767px) {
          width: 100%;
        }
      }
      .discription-videos-block-right {
        width: 50%;
        margin-top: 10px;
        @media screen and (max-width: 767px) {
          width: 100%;
        }
        .discription-videos-block-right-inner {
          width: 80%;
          margin: 0 auto;
          @media screen and (max-width: 1399px) {
            width: 100%;
          }
          @media screen and (max-width: 767px) {
            margin-bottom: 25px;
          }
        }
        .border-block {
          border: 1px solid #c2351c;
          color: #c2351c;
          padding: 25px;
          border-radius: 20px;
          text-align: left;
          box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.3);
          @media screen and (max-width: 1199px) {
            padding: 15px;
          }
          @media screen and (max-width: 767px) {
            border-radius: 10px;
          }
          p {
            font-weight: 500;
            font-size: 20px;
            line-height: 30px;
            color: #c2351c;
            margin: 0px;
            text-align: left;
            @media screen and (max-width: 1399px) {
              font-size: 18px;
              line-height: 28px;
            }
            @media screen and (max-width: 1199px) {
              font-size: 16px;
              line-height: 26px;
            }
            @media screen and (max-width: 991px) {
              font-size: 14px;
              line-height: 24px;
            }
            span {
              color: rgba(0, 0, 0, 0.6);
            }
          }
        }
        p {
          font-weight: 500;
          font-size: 20px;
          line-height: 30px;
          text-align: center;
          margin-top: 25px;
          @media screen and (max-width: 1399px) {
            font-size: 18px;
            line-height: 28px;
          }
          @media screen and (max-width: 1199px) {
            font-size: 16px;
            line-height: 26px;
            margin-top: 15px;
          }
          @media screen and (max-width: 991px) {
            font-size: 14px;
            line-height: 24px;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .test-title-block {
    font-size: 30px;
    line-height: 36px;
    color: #000;
    font-weight: 600;
    text-align: left;
    margin-bottom: 20px;
    @media screen and (max-width: 1399px) {
      font-size: 24px;
      line-height: 30px;
    }
    @media screen and (max-width: 1199px) {
      font-size: 22px;
      line-height: 28px;
    }
    @media screen and (max-width: 991px) {
      font-size: 20px;
      line-height: 26px;
    }
    @media screen and (max-width: 767px) {
      font-size: 18px;
      line-height: 26px;
    }
  }
  .test1_001 {
    .ssa.box_video {
      padding: 10px;
      background-color: #fff;
      box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      video {
        border-radius: 10px;
      }
      .video-player.detail-videos {
      }
    }
    .education {
      .popup-youtube-custom {
        padding: 20px;
        background-color: rgba(0, 0, 0, 0.1);
        border: none;
        h6 {
          font-size: 22px;
          line-height: 30px;
          color: rgba(5, 27, 170, 0.8);
          font-weight: 400;
          margin-top: 5px;
        }
        svg {
          width: 50px;
          height: 50px;
        }
      }
    }
    .box_test {
      background: transparent;
      box-shadow: none;
      padding: 0px;
      .checkbox_custom {
        margin: 0px 0px 20px;
        @media screen and (max-width: 1199px) {
          margin: 0px 0px 10px;
        }
        input {
          display: none;
        }
        label {
          position: relative;
          font-family: "Mulish", serif;
          font-size: 18px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          padding-left: 45px;
          @media screen and (max-width: 1199px) {
            font-size: 16px;
            padding-left: 30px;
          }
          @media screen and (max-width: 991px) {
            font-size: 14px;
          }
          &::before {
            content: "";
            position: absolute;
            left: 0px;
            top: 0px;
            width: 30px;
            height: 30px;
            border-radius: 4px;
            border: 1px solid #c00000;
            @media screen and (max-width: 1199px) {
              width: 22px;
              height: 22px;
            }
          }
        }
        input[type="checkbox"]:checked + label,
        input[type="radio"]:checked + label {
          &::after {
            content: "";
            position: absolute;
            left: 5px;
            top: 6px;
            background-image: url('data:image/svg+xml,<svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 21" width="27" height="21"><defs><image width="27" height="21" id="img1" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAVCAMAAACAAGUXAAAAAXNSR0IB2cksfwAAAZVQTFRFAgICAAAA/wAAqhke8B8o/yEr5SIqBAQEAAAAuhgf/yEp8Rsi+x0l1iAmAAAAAQEBSSQk9iAo8Rsi6Rsh/R4myxwkGRkZFxcXihYd/yEq5xsi6xsh/B8nsBYfAAAApRgc/h8n6Bsi7Bsi+h4lyR0mtCMt/R4m6Rsi7Boi9h0k5CEoAAAAcxkZ/h8m6Rwi7Bsh8xwj6hsnQEBA/yAp6Bsi7Bsi7Roh4yUsYhQU/yEt6Bsh7Bsi6Boh9SUtuxog/CEq1hwk7yQt6Boi7Bsi/yIq7ycw8hsi7Bsi6xsi9R0l1Roi6SMq8Rkg7Boh+x4mhxYeAgICBwcHzRsj/B0l/h8nXRcXuyQo9hsi8hsi5SEoDw8Pxhoj6xoi6hoi4B4lVRUV/x0m6xwj6Roh8SAoEBAQzxkf9Rwk7Bsi/R8m/yEq6xsi/yEp6iEq6Roh5xsh/x8n6Bsh9B0kwBoh6xsh6hoh5iAnDQ0Nvh4m7xoh/CAp6xsi6xoh2hwlwhge7Rsh6Roi/yAo1h0kRhcX9hwj7x8q9CUsohIZ9dR17AAAAId0Uk5TAAAAWdf/pAAEa/37/1gBAAfl/fb/QAAAFf/59/86Aw/V9/n/PROs7/r/TQIY8Pf8/nAE//j8+60N+Pj++t5h9WTN+v//h/37+/9hi/v8/yIBAGL//wtA//x0ADr6+rgM//n61gBb/v3/+v//vvn5+vn/Rfv7wgBe/fj9+1p+/Pr/aQv/09hHS5UQ6wAAAV1JREFUeJxl0T1Iw0AUB/D3F/qBeqkIKggRhEIhjoq2QqGDDg6iuHV2UHRwURBcHNx0FhR0cHFx0E2HDoKDtVi/IINYQYI4dBBzDk1V4uXy0Za84T7y4+7eewHBBpFNToC8gBM/CPZOROtiiFlxaYSEqRCZRErNooSYibVJsYg3zvXApqqY+yTBcG6m1hiQUjcobElJ3waFTHPvq3AKWcy1G+Yb42NFzeAy+bRDVx4Jy6Lyl7oUe8ZzwFdXQTX8DkwCvxHgTSeWxWc38KLPnM2eSpvD3SBFOqHzNF6jKh518TV/LE2Zvs58UD9uR4DnFA7lY/MH7nvauLjHHN5bLI2eT+3GLNE+0zfGl1GODwFPyXacOHk0jFRjKX4vlrUMdmR+Nta2/drVPEpi+d5RdtNXTL8+8Vf4Ooq1XLX3yK2s2YitoDABbHo1t9rq/gIeLsjrlY0mI9rCRtCq4Nw/KoppOHc6By0AAAAASUVORK5CYII="/></defs><style></style><use id="Background" href="%23img1" x="0" y="0"/></svg>');
            width: 25px;
            height: 19px;
            background-size: contain;
            /* transform: translate(-50%, -50%); */
            @media screen and (max-width: 1199px) {
              width: 14px;
              height: 11px;
            }
          }
        }
      }
      .text-area {
        background: transparent;
        padding: 0px;
        .form-label {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          span {
            padding-left: 5px;
          }
        }
        textarea {
          min-height: 120px;
          border: 1px solid rgba(0, 0, 0, 0.2);
          border-radius: 10px;
          padding: 10px;
        }
      }
      .border-b {
        padding-top: 10px;
        .theme-btn-link-black {
          font-family: "Mulish", serif;
          font-size: 14px;
          line-height: 20px;
          height: auto;
          text-transform: capitalize;
        }
      }
    }
  }
  .assestmentd1_002,
  .assestmentd1_003 {
    .suggested {
      display: flex;
      justify-content: flex-start;
      li {
        padding-left: 25px;
        &::before {
          width: 18px;
          height: 18px;
          top: 1px;
        }
      }
    }
    .box_p.shadow_box {
      padding: 20px;
      background-color: #fff;
      box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      font-family: "Mulish", serif;
    }
    .img_box {
      border: none;
      height: 220px;
      border: none;
    }
    .time_list {
      height: auto;
      li {
        position: relative;
        padding-left: 20px;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0px;
        }
        &::before {
          content: "";
          position: absolute;
          left: 0px;
          top: 7px;
          width: 6px;
          height: 6px;
          background-color: #000;
          border-radius: 50%;
        }
        span {
          margin-bottom: 0px;
          width: auto;
          color: rgba(0, 0, 0, 0.4);
          &.red {
            color: #000;
          }
        }
      }
    }
    .nav-tabs {
      .summary_box {
        &.summary_box-custom {
          /* height: 100%; */
          height: auto;
          margin-bottom: 0px;
          box-shadow: none;
          background-color: transparent;
          h6 {
            margin-bottom: 10px;
          }
          .common-box-bg-all {
            height: 100%;
            @media screen and (max-width: 991px) {
              padding: 5px;
              border-radius: 10px;
            }
            .summary_box_levelimg1 {
              border: none;
              height: 220px;
            }
            .summary_title_box {
              margin-bottom: 0px;
              @media screen and (max-width: 991px) {
                table {
                  th {
                    font-size: 11px;
                  }
                  td {
                    font-size: 10px;
                  }
                }
              }
              h6 {
                font-size: 16px;
                line-height: 22px;
                color: #000;
              }
              .summary_time_list {
                height: auto;
                li {
                  position: relative;
                  padding-left: 20px;
                  margin-bottom: 10px;
                  &:last-child {
                    margin-bottom: 0px;
                  }
                  &::before {
                    content: "";
                    position: absolute;
                    left: 0px;
                    top: 7px;
                    width: 6px;
                    height: 6px;
                    background-color: #000;
                    border-radius: 50%;
                  }
                  span {
                    margin-bottom: 0px;
                    color: rgba(0, 0, 0, 0.4);
                    &.red {
                      color: #000;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .display-flex-block-btn {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .programe-not-assign {
    padding: 70px 0px;
    text-align: center;
    .test-title-block {
      text-align: center;
    }
  }
  .search-block-custom {
    padding: 50px 150px;
    position: relative;
    width: 100%;
    @media screen and (max-width: 1399px) {
      padding: 40px 15px 30px;
    }
    @media screen and (max-width: 991px) {
      padding: 40px 15px 15px;
    }
    .rounded-pill {
      height: 70px;
      border-radius: 10px !important;
      font-family: "Mulish", serif;
      font-weight: 400;
      font-size: 20px;
      border-color: rgba(0, 0, 0, 0.2);
      padding: 0px 90px;
      @media screen and (max-width: 1199px) {
        height: 60px;
        font-size: 16px;
        padding: 0px 65px;
      }
      @media screen and (max-width: 767px) {
        height: 45px;
        font-size: 14px;
        padding: 0px 50px;
      }
    }
    button {
      top: 63px;
      position: absolute;
      width: 45px;
      height: 45px;
      border-radius: 50%;
      border: none;
      left: 170px;
      background-color: rgba(0, 0, 0, 0.1);
      @media screen and (max-width: 1399px) {
        left: 25px;
        top: 53px;
      }
      @media screen and (max-width: 1199px) {
        width: 40px;
        height: 40px;
        top: 51px;
        left: 25px;
      }
      @media screen and (max-width: 767px) {
        width: 30px;
        height: 30px;
        top: 48px;
        svg {
          width: 13px;
        }
      }
    }
  }
  .product-block-reco {
    .mb-col-buy {
      margin-bottom: 30px;
      .product-box {
        padding-bottom: 0px;
        &.full-height-block {
          height: 100%;
        }
      }
    }
    .product-box {
      margin-bottom: 30px;
      border: 1px solid #fff;
      max-height: 100%;
      @media screen and (max-width: 1199px) {
        padding: 10px;
        margin-bottom: 15px;
      }
      @media screen and (max-width: 991px) {
        border-radius: 10px;
        &.full-height-block {
          .product-info {
            .text-uppercase {
              font-size: 14px;
            }
          }
        }
      }
      @media screen and (max-width: 767px) {
        &.full-height-block {
          display: flex;
          align-items: center;
          .p-2 {
            padding-top: 0px !important;
          }
        }
      }
      &.full-height-block {
        padding-bottom: 120px;
        position: relative;
        @media screen and (max-width: 767px) {
          padding-bottom: 60px;
          .product-box-inner {
            width: 40%;
            padding-right: 5px;
            .product-img {
              height: auto;
              max-height: inherit;
            }
          }
          .mt-3.p-2 {
            width: 60%;
            margin: 0px !important;
          }
        }
        .last-block-flex-buy {
          position: absolute;
          bottom: 30px;
          left: 0px;
          right: 0px;
          @media screen and (max-width: 767px) {
            bottom: 10px;
          }
        }
      }
      .product-box-img {
        width: 100%;
        height: 250px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        @media screen and (max-width: 1199px) {
          height: 200px;
        }
        @media screen and (max-width: 991px) {
          height: 140px;
        }
        @media screen and (max-width: 767px) {
          height: 120px;
        }
        img {
          width: 100%;
          height: 100%;
          max-height: max-content;
        }
      }
      &:hover {
        border-color: #c00000;
      }
      .product-info {
        h3 {
          text-align: center;
          @media screen and (max-width: 1199px) {
            font-size: 16px;
          }
          @media screen and (max-width: 991px) {
            font-size: 14px;
          }
          @media screen and (max-width: 767px) {
            font-size: 13px;
          }
        }
        .text-uppercase {
          text-transform: capitalize !important;
          margin-bottom: 5px;
        }
        .product-desc {
          font-size: 16px;
          line-height: 18px;
          color: rgba(0, 0, 0, 0.4);
          @media screen and (max-width: 991px) {
            font-size: 13px;
            line-height: 16px;
          }
        }
        .btn-expand-read {
          color: #c00000;
          text-decoration: underline;
          margin-top: 10px;
        }
      }
      .product-comments {
        font-family: "Mulish", serif;
        font-weight: 500;
        font-size: 16px;
        @media screen and (max-width: 991px) {
          font-size: 13px;
          line-height: 16px;
        }
      }
      .btn-expand-read {
        color: #c00000;
        text-decoration: underline;
        margin-top: 5px;
      }
    }
  }
  .share-kit-block {
    padding: 50px 0px 30px;
    @media screen and (max-width: 1399px) {
      padding: 30px 0px 20px;
    }

    .kit {
      padding: 40px;
      @media screen and (max-width: 1399px) {
        padding: 15px;
      }
      @media screen and (max-width: 991px) {
        margin-bottom: 15px;
      }
      @media screen and (max-width: 767px) {
        flex-direction: row;
      }
      .title-inner-block {
        padding-right: 25px;
        margin: 0px;
        padding-bottom: 0px;
        @media screen and (max-width: 1399px) {
          padding-right: 10px;
        }
      }
      .links-icons {
        @media screen and (max-width: 767px) {
          width: auto;
        }
        li {
          padding: 0px 5px;
          margin: 0px;
          background: transparent;
          a {
            background-color: #c00000;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            padding: 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            @media screen and (max-width: 1399px) {
              width: 35px;
              height: 35px;
              svg {
                width: 18px;
                font-size: 18px;
              }
            }
          }
        }
      }
    }
    .media-preview-row {
      display: flex;
      gap: 16px;
      align-items: center;
      margin-top: 16px;
    }
    .social-profile {
      padding-left: 0px;
      padding-right: 0px;
      border-left: none;
      @media screen and (max-width: 767px) {
        width: 100%;
        border: none;
      }
      &:after {
        content: none;
      }
      .content {
        padding: 40px;
        @media screen and (max-width: 1399px) {
          justify-content: space-between;
        }
        @media screen and (max-width: 1399px) {
          padding: 15px;
          .theme-common-btn-small {
            padding: 10px 23px;
            font-size: 16px;
            line-height: 16px;
          }
          figure {
            width: auto;
            img {
              width: 100px;
            }
          }
          .wrapper {
            width: auto;
            min-width: auto;
            max-width: fit-content;

            h3 {
              font-size: 22px;
              @media screen and (max-width: 767px) {
                font-size: 15px;
              }
            }
          }
        }
        @media screen and (max-width: 767px) {
          padding: 15px;
          .theme-common-btn-small {
            padding: 14px 12px;
            font-size: 14px;
            line-height: 1px;
          }
          figure {
            width: auto;
            img {
              width: 80px;
            }
          }
        }
        &:after {
          content: none;
        }
        figure {
          &:after {
            content: none;
          }
        }
        .wrapper {
          padding: 4px 0px;
        }
      }
    }
  }
  .row-musical-block {
    .link-block-musical-main {
      margin-bottom: 50px;
      .link-block-musical-main-inner {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        .category-box-inner {
          width: 16.6%;
          padding: 5px;
          @media screen and (max-width: 1199px) {
            width: 25%;
          }
          @media screen and (max-width: 991px) {
            width: 33.33%;
          }
          @media screen and (max-width: 767px) {
            width: 100%;
          }
          .theme-common-btn-big {
            font-weight: 400;
            cursor: pointer;
            padding: 18px 10px;
            font-size: 16px;
            @media screen and (max-width: 1399px) {
              min-width: 175px;
              padding: 16px 10px;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .mb-custom-30 {
    margin-bottom: 30px;
  }
  .library-img-container-main-inner {
    height: 100%;
    .library-img-container-main {
      height: 100%;
      width: 100%;
      max-width: 100%;
      .library-nav {
        height: auto;
        padding: 20px !important;
        border: none !important;
        border: 1px solid transparent !important;
        width: 100%;
        @media screen and (max-width: 1199px) {
          padding: 15px !important;
        }
        @media screen and (max-width: 991px) {
          padding: 10px !important;
        }
        @media screen and (max-width: 767px) {
          padding: 5px !important;
          border-radius: 10px;
          height: 100%;
        }
        &:hover {
          border-color: #c00000 !important;
          .library-img-container-inner {
            .title-one,
            .title-two {
              color: #c00;
            }
          }
        }
        .library-img-container {
          padding: 0px;
          background: transparent;
          border: none !important;
          box-shadow: none;
          margin: 0px;
          border-radius: 0px;
        }
        .library-img-box {
          width: 100%;
          height: 220px;
          border: none;
          background: transparent;
          margin-bottom: 20px;
          @media screen and (max-width: 1199px) {
            height: 130px;
            margin-bottom: 15px;
          }
          @media screen and (max-width: 991px) {
            height: 100px;
            margin-bottom: 15px;
          }
          @media screen and (max-width: 767px) {
            height: 70px;
            margin-bottom: 5px;
          }
        }
      }
      .library-img-container-inner {
        @media screen and (max-width: 767px) {
          height: auto;
        }
        .title-one {
          font-size: 16px;
          line-height: 20px;
          @media screen and (max-width: 991px) {
            font-size: 13px;
            line-height: 18px;
            word-wrap: break-word;
            .title-two {
              font-size: 10px;
            }
          }
          @media screen and (max-width: 767px) {
            font-size: 10px;
            line-height: 16px;
            .title-two {
              font-size: 7px;
            }
          }
        }
        .title-two {
          @media screen and (max-width: 991px) {
            font-size: 10px;
          }
          @media screen and (max-width: 767px) {
            font-size: 7px;
          }
        }
      }
    }
  }
  .mb-custom-block {
    margin-bottom: 50px;
    @media screen and (max-width: 1399px) {
      margin-bottom: 30px;
      .Educational-info {
        margin: 15px 0px !important;
      }
    }
    @media screen and (max-width: 767px) {
      .col-3.mb-custom-30 {
        padding: 5px;
        margin-bottom: 10px;
        flex: 0 0 33.33%;
        max-width: 33.33%;
      }
      .library-empty-page {
        height: 90px;
        border: 1px solid gray;
        .itemsPerPagelabel {
          font-size: 18px;
        }
      }
    }
  }
  .videos-music-library-block {
    padding: 10px 0px;
    @media screen and (max-width: 1399px) {
      padding: 20px 0px;
    }
    .wrapper {
      padding: 0px;
      .slider-main-block-details {
        display: flex;
        @media screen and (max-width: 767px) {
          display: block;
        }
        .slider-main-block-details-inner-main {
          width: 75%;
          padding: 0px;
          @media screen and (max-width: 767px) {
            width: 100%;
          }
          .slick-dots {
            display: none !important;
          }
          .library-inner-thumb-two-main {
            padding: 20px;
            @media screen and (max-width: 1399px) {
              padding: 10px;
            }
            .library-inner-thumb-two {
              border: 1px solid #c00;
              /* height: 600px; */
              height: 570px;
              @media screen and (max-width: 1399px) {
                height: 450px;
              }
              @media screen and (max-width: 767px) {
                height: 235px;
                border: none;
                padding: 10px;
                border-radius: 10px;
              }
              .block-img-two-sync {
                width: 100%;
                height: 460px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 30px;
                @media screen and (max-width: 1399px) {
                  height: 350px;
                }
                @media screen and (max-width: 767px) {
                  height: 150px;
                  margin-bottom: 15px;
                }
                > img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }
              .detail-box {
                h6 {
                  padding-bottom: 10px;
                  font-size: 26px;
                  line-height: 26px;
                  color: #c00000;
                  font-weight: 600;
                  margin: 0px !important;
                  padding: 0px;
                  span {
                    color: #c00000;
                  }
                  @media screen and (max-width: 1399px) {
                    font-size: 20px;
                    line-height: 24px;
                    padding-bottom: 5px;
                  }
                  @media screen and (max-width: 767px) {
                    font-size: 18px;
                    line-height: 22px;
                    padding-bottom: 5px;
                  }
                }
              }
            }
          }
        }
        .slider-main-block-details-inner-thumb {
          width: 25%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 570px;
          align-items: center;
          /* padding: 10px 20px; */
          @media screen and (max-width: 1399px) {
            height: 450px;
          }
          @media screen and (max-width: 767px) {
            height: auto;
            flex-direction: row;
            width: 100%;
          }
          .slider-main-block-details-inner-thumb-inner {
            width: 100%;
            /* padding-right: 15px; */
            @media screen and (max-width: 767px) {
              width: 75%;
              padding-right: 10px;
            }
            .library-inner-thumb {
              width: 100%;
              height: 200px;
              height: 145px;
              padding: 20px;
              background-color: #fff;
              box-shadow: 0px 5px 5px 5px rgba(0, 0, 0, 0.04);
              border-radius: 20px;
              font-family: "Mulish", serif;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px solid #c00;
              border: none;
              margin: 0px;
              @media screen and (max-width: 1399px) {
                height: 100px;
              }
              @media screen and (max-width: 767px) {
                padding: 10px;
                border-radius: 10px;
              }
            }
          }
          .library-inner-thumb-inner {
            width: 100%;
            padding-left: 15px;
            padding: 20px;
            background-color: #fff;
            box-shadow: 0px 5px 5px 5px rgba(0, 0, 0, 0.04);
            border-radius: 20px;
            font-family: "Mulish", serif;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            /* height: 200px; */
            height: 145px;
            cursor: pointer;
            @media screen and (max-width: 1399px) {
              height: 100px;
              padding: 10px;
            }
            @media screen and (max-width: 767px) {
              width: 25%;
              border-radius: 10px;
            }
            .video-icon {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              background-color: #c00000;
              display: flex;
              align-items: center;
              justify-content: center;
              @media screen and (max-width: 1399px) {
                width: 45px;
                height: 45px;
              }
              @media screen and (max-width: 767px) {
                width: 30px;
                height: 30px;
              }
              svg {
                fill: #fff;
                width: 25px;
                height: 25px;
                @media screen and (max-width: 1399px) {
                  width: 20px;
                  height: 20px;
                }
                @media screen and (max-width: 767px) {
                  width: 15px;
                  height: 15px;
                }
              }
            }
            .video-icon-inner {
              margin-top: 15px;
              font-size: 18px;
              color: #000;
              @media screen and (max-width: 1399px) {
                margin-top: 10px;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
    .slide-content {
      height: 100%;
      padding: 0px 0px;
      @media screen and (max-width: 991px) {
        margin-top: 15px;
      }
      p {
        margin-bottom: 8px;
        font-size: 16px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.4);
        @media screen and (max-width: 1399px) {
          font-size: 14px;
          line-height: 18px;
        }
        strong {
          font-size: 24px;
          line-height: 30px;
          color: #000;
          font-weight: 700;
          margin-top: 15px;
          display: block;
          @media screen and (max-width: 1399px) {
            font-size: 20px;
            line-height: 24px;
            margin-top: 5px;
          }
          @media screen and (max-width: 991px) {
            font-size: 18px;
            line-height: 22px;
          }
        }
        &.body-type-note {
          strong {
            color: #c00000;
          }
        }
      }
    }
    .slide-content-details {
      height: 100%;
      padding: 0px 0px;
      .details-description ul {
        list-style-type: disc !important;
        padding-left: 30px;
        font-size: 12px;
      }
      @media screen and (max-width: 991px) {
        margin-top: 15px;
      }
    }
  }
  .human-body-container {
    width: 100%;
    display: block;
    margin: 0px;
    .human-body-container-inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      margin-bottom: 5px;
      padding: 5px 140px;
      h4 {
        flex: 1;
        text-align: center;
        margin: 0;
      }
      @media screen and (max-width: 1399px) {
        padding: 5px 15px;
        h3 {
          font-size: 20px;
          line-height: 24px;
        }
        h4 {
          font-size: 18px;
        }
      }
      @media screen and (max-width: 767px) {
        position: relative;
        z-index: 9;
        h3 {
          font-size: 16px;
          line-height: 20px;
        }
        h4 {
          font-size: 18px;
        }
      }
      button {
        position: absolute;
        right: 0; /* move button to far right */
        width: 80px;
        height: 80px;
        background: transparent;
        border: none;
        box-shadow: none;
        @media screen and (max-width: 1399px) {
          transform: scale(0.7);
        }
        @media screen and (max-width: 767px) {
          transform: scale(0.5);
          top: 20px;
        }
        svg {
          width: 50px;
          height: 50px;
        }
      }
    }

    .common-front-trigger {
      margin: 0 auto;
      display: table;
      @media screen and (max-width: 1399px) {
        margin: 0 auto 20px;
      }
      @media screen and (max-width: 767px) {
        position: relative;
        top: -20px;
      }
      .common-front-trigger-inner {
        > div {
          @media screen and (max-width: 767px) {
            height: 330px;
          }
        }
      }
    }
  }
  span {
    .custom-red {
      color: red;
    }
  }
  .theme-bottom-btn-block {
    margin-top: 15px;
    padding: 12px;
    font-size: 20px;
    line-height: 20px;
    color: #fff;
    border-radius: 10px;
    background-color: #c00000;
    font-weight: 700;
    min-width: 200px;
  }
  .assessment-block {
    padding: 70px 0px;
    @media screen and (max-width: 1399px) {
      padding: 50px 0px;
    }
    @media screen and (max-width: 1199px) {
      padding: 40px 0px;
    }
    @media screen and (max-width: 767px) {
      padding: 30px 0px;
    }
    .title-last-assessment {
      font-size: 20px;
      line-height: 26px;
      color: #000;
      @media screen and (max-width: 991px) {
        font-size: 20px;
      }
      @media screen and (max-width: 767px) {
        font-size: 18px;
      }
    }
    .assessment-block-inner {
      width: 60%;
      margin: 0 auto;
      text-align: center;
      @media screen and (max-width: 991px) {
        width: 100%;
      }
      h3 {
        font-size: 20px;
        line-height: 26px;
        padding: 0px 0px 20px 0px;
        @media screen and (max-width: 991px) {
          font-size: 20px;
        }
        @media screen and (max-width: 767px) {
          font-size: 18px;
        }
      }

      .assessment-block-inner-video {
        background-color: #fff;
        box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.08);
        border-radius: 10px;
        padding: 10px;
        margin-bottom: 30px;
        @media screen and (max-width: 991px) {
          margin-bottom: 15px;
          padding: 5px;
        }
        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px;
        }
      }

      .btn-assessment {
        margin-top: 30px;
        @media screen and (max-width: 991px) {
          margin-top: 15px;
          button {
            margin: 0px 5px !important;
          }
        }
      }
    }
    .assessment-block-summary {
      display: flex;
      align-items: center;
      margin: 0px -10px;
      flex-wrap: wrap;
      justify-content: center;
      @media screen and (max-width: 767px) {
        margin: 0px -5px;
        align-items: stretch;
      }
      .assessment-block-summary-inner {
        padding: 0px 10px 20px;
        width: 16.6%; /* 6 columns on desktop */
        @media screen and (max-width: 1199px) {
          width: 25%; /* 4 columns on large tablets */
        }
        @media screen and (max-width: 991px) {
          width: 33.33%; /* 3 columns on tablets */
        }
        @media screen and (max-width: 767px) {
          width: 50%; /* 2 columns on mobile */
          padding: 0px 5px 15px;
        }
        @media screen and (max-width: 575px) {
          width: 100%; /* 1 column on small mobile */
          padding: 0px 5px 15px;
        }
        .assessment-block-summary-inner-flex {
          width: 100%;
          height: 300px;
          padding: 20px;
          background-color: #fff;
          box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
          border-radius: 20px;
          font-family: "Mulish", serif;
          border: 2px solid transparent;
          position: relative;
          display: flex;
          flex-direction: column;
          @media screen and (max-width: 991px) {
            height: 280px;
            padding: 15px;
            border-radius: 15px;
          }
          @media screen and (max-width: 767px) {
            height: 260px;
            padding: 12px;
            border-radius: 12px;
            box-shadow: 0px 5px 15px 5px rgba(0, 0, 0, 0.04);
          }
          @media screen and (max-width: 575px) {
            height: auto;
            min-height: 240px;
            padding: 15px;
          }
          .info-pages-flex {
            width: 100%;
            height: 220px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            @media screen and (max-width: 991px) {
              height: 200px;
            }
            @media screen and (max-width: 767px) {
              height: 180px;
            }
            @media screen and (max-width: 575px) {
              height: 160px;
            }
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
            video {
              width: 100%;
              height: 100%;
              object-fit: contain;
              border-radius: 8px;
              @media screen and (max-width: 767px) {
                border-radius: 6px;
              }
            }
          }
          .profile-img {
            position: absolute;
            top: 15px;
            left: 15px;
            @media screen and (max-width: 767px) {
              top: 12px;
              left: 12px;
            }
            img {
              width: 24px;
              height: 24px;
              @media screen and (max-width: 767px) {
                width: 20px;
                height: 20px;
              }
            }
          }
          .title-box {
            text-align: center;
            padding-top: 15px;
            flex-shrink: 0;
            @media screen and (max-width: 767px) {
              padding-top: 10px;
            }
            h6 {
              font-size: 16px;
              line-height: 20px;
              color: #000;
              font-weight: 400;
              @media screen and (max-width: 991px) {
                font-size: 16px;
                line-height: 20px;
              }
              @media screen and (max-width: 767px) {
                font-size: 14px;
                line-height: 18px;
              }
            }
          }
        }
      }
    }
    .upload-img-input {
      padding: 20px;
      background-color: #fff;
      box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      height: 400px;
      width: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .upload-input-type-file {
      margin: 25px auto;
      display: table;
      @media screen and (max-width: 991px) {
        margin: 15px auto;
      }
      &.full-width {
        width: 100%;
        label {
          width: 100%;
        }
      }
      .camero-angle-block {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
        gap: 15px;
        .theme-common-btn-small {
          border: none;
          cursor: pointer;
        }
      }
      input[type="file"] {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
      }
      label {
        width: 500px;
        height: 135px;
        padding: 20px;
        border-radius: 10px;
        background-color: rgba(0, 0, 0, 0.04);
        border: 1px solid rgba(0, 0, 0, 0.2);
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        @media screen and (max-width: 991px) {
          width: 100%;
          height: 100px;
          padding: 20px;
        }
        h4 {
          font-size: 24px;
          color: rgba(0, 0, 0, 0.3);
          font-weight: 500;
          margin-top: 15px;
          @media screen and (max-width: 991px) {
            font-size: 20px;
          }
          @media screen and (max-width: 767px) {
            font-size: 18px;
          }
        }
      }
    }
  }
  .videos-front-public {
    .videos-front-public {
      padding: 50px 0px;
      .Educational-info {
        margin-top: 0px !important;
        h3 {
          font-weight: 600;
          margin-bottom: 15px;
          @media screen and (max-width: 767px) {
            font-size: 18px;
          }
        }
        ul {
          padding-left: 18px;
          li {
            color: rgba(0, 0, 0, 0.4);
            margin-bottom: 5px;
          }
        }
      }
    }
    .col-flex-flex-end {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      .test_videobox-education {
        width: 350px;
        @media screen and (max-width: 767px) {
          width: 100%;
          margin-top: 15px;
          height: auto;
        }
      }
    }
  }
  .test1_001 {
    .timer_box {
      .border_1 {
        @media screen and (max-width: 767px) {
          padding: 10px 0px;
          li {
            width: auto;
            padding: 0 10px !important;
            > div {
              width: 80px !important;
              height: 70px !important;
              padding: 5px !important;
              input {
                font-size: 14px !important;
              }
              p {
                font-size: 10px !important;
              }
            }
          }
          .timer-btn {
            width: 80px !important;
            height: 70px !important;
            small {
              font-size: 10px;
              line-height: 15px;
            }
          }
          .theme_btn_yellow {
            width: 80px !important;
            height: 70px !important;
            margin: 0px 10px 0px 0px !important;
            padding: 5px !important;
            font-size: 14px !important;
          }
          .btn-finish {
            width: 80px !important;
            height: 70px !important;
            margin: 0px 10px 0px 0px !important;
            padding: 5px !important;
            font-size: 14px !important;
          }
          .theme_btn1 {
            width: 80px !important;
            height: 70px !important;
            margin: 0px 10px 0px 0px !important;
            padding: 5px !important;
            font-size: 14px !important;
          }
        }
        + ul {
          @media screen and (max-width: 767px) {
            padding: 10px 0px;
            li {
              width: auto;
              padding: 0 2px !important;
              > div {
                width: 80px !important;
                height: 70px !important;
                padding: 5px !important;
                input {
                  font-size: 14px !important;
                }
                p {
                  font-size: 10px !important;
                }
                a.edu.popup-youtube-custom h6 {
                  font-size: 10px !important;
                  line-height: 14px !important;
                }
                a.edu.popup-youtube-custom {
                  svg {
                    width: 25px;
                    height: 24px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .notifacation-text {
    ul {
      /* padding: 20px; */
      background-color: #fff;
      box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      font-family: "Mulish", serif;
      border: 2px solid transparent;
      .notification-item {
        padding: 20px;
        border-bottom: 1px solid #c00000;
        &:last-child {
          border: none;
        }
        h4 {
          padding-bottom: 10px;
          font-size: 22px;
          line-height: 26px;
          color: #000;
          font-weight: 600;
          @media screen and (max-width: 991px) {
            font-size: 18px;
            line-height: 22px;
          }
        }
        p {
          font-size: 18px;
          line-height: 24px;
          color: #000;
          @media screen and (max-width: 991px) {
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }
  }
  .assesment-info {
    padding: 70px 0px;
    @media screen and (max-width: 991px) {
      padding: 50px 0px;
    }
    > p {
      font-weight: 500;
      font-size: 24px;
      line-height: 40px;
      color: #000;
      text-align: center;
      padding: 0px 15px;
    }
    .assesment-info-block {
      padding-top: 50px;
      display: flex;
      gap: 30px;
      .assesment-info-block-left {
        width: 50%;
        h3 {
          font-size: 30px;
          text-align: left;
          line-height: 40px;
          color: #000;
          font-weight: 600;
          margin-bottom: 25px;
          span {
            color: #c00;
          }
          @media screen and (max-width: 1399px) {
            font-size: 22px;
            line-height: 32px;
            margin-bottom: 20px;
          }
          @media screen and (max-width: 1199px) {
            font-size: 20px;
            line-height: 30px;
            margin-bottom: 15px;
          }
        }
        ol {
          list-style: none;
          counter-reset: li;
          li {
            counter-increment: li;
            position: relative;
            padding-bottom: 20px;
            &::before {
              content: counter(li);
              color: #c00300;
              display: inline-block;
              /* width: 5em; */
              margin-left: 0;
              margin-right: 0;
              /* text-align: right; */
              /* direction: rtl; */
              position: absolute;
              left: -30px;
              right: 0px;
              font-size: 22px;
              font-weight: bold;
              top: -2px;
            }
            h3 {
              font-size: 22px;
              line-height: 28px;
              text-align: left;
              color: #c00300;
              font-weight: 600;
              margin-bottom: 5px;
              span {
                color: #c00;
              }
              @media screen and (max-width: 1399px) {
                font-size: 22px;
                line-height: 32px;
                margin-bottom: 20px;
              }
              @media screen and (max-width: 1199px) {
                font-size: 20px;
                line-height: 30px;
                margin-bottom: 15px;
              }
            }
            > p {
              font-weight: 500;
              font-size: 16px;
              line-height: 26px;
              color: #000;
            }
          }
        }
      }
      .assesment-info-block-right {
        width: 50%;
        .assesment-info-block-right-inner {
          width: 75%;
          margin: 0 auto;
          display: table;
          h3 {
            font-size: 30px;
            text-align: center;
            line-height: 40px;
            color: #c00;
            font-weight: 500;
            margin-bottom: 40px;
            span {
              font-weight: 600;
            }
            @media screen and (max-width: 1399px) {
              font-size: 22px;
              line-height: 32px;
              margin-bottom: 20px;
            }
            @media screen and (max-width: 1199px) {
              font-size: 20px;
              line-height: 30px;
              margin-bottom: 15px;
            }
          }
          .assesment-info-box {
            box-shadow: 4px 4px 9px 0px rgba(0, 0, 0, 0.6);
            background-color: #e6e6e6;
            padding: 35px 20px;
            border-radius: 20px;
            h4 {
              font-size: 20px;
              line-height: 28px;
              text-align: left;
              color: #000;
              font-weight: 600;
              margin-bottom: 10px;
              span {
                color: #c00;
              }
              @media screen and (max-width: 1399px) {
                font-size: 18px;
                line-height: 26px;
              }
              @media screen and (max-width: 1199px) {
                font-size: 16px;
                line-height: 24px;
              }
            }
            ul {
              list-style: disc;
              padding-left: 18px;
              li {
                font-weight: 400;
                font-size: 16px;
                line-height: 26px;
                color: #000;
                margin-bottom: 5px;
                &:last-child {
                  margin-bottom: 0px;
                }
              }
            }
          }
          .btn-block-assesment {
            margin: 40px auto;
            display: table;
          }
        }
      }
    }
    .assesment-info-finised {
      text-align: center;
      h2 {
        color: #000;
        margin-bottom: 30px;
        font-size: 2.25rem;
        line-height: 40px;
        text-align: center;
        font-weight: 500;
        @media screen and (max-width: 991px) {
          font-size: 30px;
          line-height: 30px;
        }
      }
      p {
        font-size: 30px;
        line-height: 45px;
        text-align: center;
        @media screen and (max-width: 991px) {
          font-size: 24px;
          line-height: 40px;
          br {
            display: none;
          }
        }
        @media screen and (max-width: 767px) {
          br {
            display: none;
          }
        }
      }
      .btn-block-assesment {
        margin-top: 15px;
      }
    }
  }
  .common-data-back-step-one {
    text-align: left;
    padding: 50px 0px;
    position: relative;
    @media screen and (max-width: 1199px) {
      padding: 40px 0px;
    }
    @media screen and (max-width: 1500px) {
      width: 1170px;
      margin: 0 auto;
    }
    @media screen and (max-width: 1200px) {
      width: 950px;
    }
    @media screen and (max-width: 991px) {
      width: 100%;
    }
    .other-content-cls {
      width: 800px;
      margin: 0 auto;
      @media screen and (max-width: 991px) {
        width: 100%;
      }
    }
    .image-cls {
      @media screen and (max-width: 1500px) {
        margin: 0 auto;
      }
      span {
        display: flex;
        align-items: center;
        @media screen and (max-width: 991px) {
          display: block;
        }
        img {
          width: 50%;
          height: auto;
          object-fit: unset;
          padding: 50px;
          @media screen and (max-width: 1199px) {
            padding: 30px;
          }
          @media screen and (max-width: 991px) {
            padding: 15px;
          }
          @media screen and (max-width: 767px) {
            padding: 0px 0px 25px 0px;
            height: 78dvh !important;
            object-fit: contain !important;
          }
          &:nth-child(2) {
            padding: 70px;
            @media screen and (max-width: 1199px) {
              padding: 40px;
            }
            @media screen and (max-width: 991px) {
              padding: 15px;
            }
            @media screen and (max-width: 767px) {
              /* padding: 0px 0px 25px 0px; */
              height: 70dvh !important;
              object-fit: contain !important;
            }
          }
          @media screen and (max-width: 991px) {
            width: 100%;
          }
          @media screen and (max-width: 991px) {
            width: 100%;
            height: 100vh;
            object-fit: contain;
          }
          @media screen and (max-width: 767px) {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      + .btn-block-assesment {
        position: absolute;
        bottom: 80px;
        right: 200px;
        @media screen and (max-width: 1500px) {
          bottom: 80px;
          right: 160px;
        }
        @media screen and (max-width: 1200px) {
          bottom: 50px;
          right: 120px;
        }
        @media screen and (max-width: 991px) {
          position: unset;
        }
        .theme-common-btn-big {
          width: 300px;
          padding: 16px 10px;
          @media screen and (max-width: 1500px) {
            width: 250px;
            padding: 12px 10px;
          }
          @media screen and (max-width: 1200px) {
            width: 230px;
            padding: 11px 10px;
          }
        }
      }
    }
    h3 {
      color: #000;
      margin-bottom: 25px;
      font-size: 22px;
      line-height: 30px;
      text-align: center;
      font-weight: 600;
      @media screen and (max-width: 1399px) {
        font-size: 20px;
        line-height: 28px;
      }
      @media screen and (max-width: 991px) {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 20px;
      }
      @media screen and (max-width: 767px) {
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 15px;
      }
      @media screen and (max-width: 767px) {
        /* font-size: 12px; */
      }
    }
    p {
      color: #000;
      margin-bottom: 25px;
      font-size: 22px;
      line-height: 30px;
      text-align: center;
      font-weight: 600;
      @media screen and (max-width: 1399px) {
        font-size: 20px;
        line-height: 28px;
      }
      @media screen and (max-width: 991px) {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 20px;
      }
      @media screen and (max-width: 767px) {
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 15px;
      }
      @media screen and (max-width: 767px) {
        /* font-size: 12px; */
      }
    }
    ul {
      list-style: disc;
      padding-left: 18px;
      li {
        color: rgba(0, 0, 0, 0.6);
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 30px;
        text-align: left;
        @media screen and (max-width: 1399px) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
    ol {
      padding-left: 18px;
      li {
        color: rgba(0, 0, 0, 0.6);
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 30px;
        text-align: left;
        @media screen and (max-width: 1399px) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
    .btn-block-assesment {
      margin: 0 auto;
      display: table;
      .theme-common-btn-big {
        width: 400px;
        padding: 12px 10px;
        @media screen and (max-width: 1399px) {
          width: 320px;
          padding: 10px 10px;
          font-size: 16px;
        }
        @media screen and (max-width: 767px) {
          width: 280px;
          padding: 10px 10px;
          font-size: 14px;
        }
        span {
          font-weight: 400;
          display: block;
          font-size: 16px;
          line-height: 22px;
          @media screen and (max-width: 1399px) {
            font-size: 13px;
            line-height: 20px;
          }
          @media screen and (max-width: 767px) {
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
    }
  }
`;

export const HomePage = styled.div`
  .common-container {
    max-width: 1730px;
    margin: 0 auto;
    padding: 0px 15px;
  }
  .banner-section-block {
    height: 100vh;
    /* background: url(../../../components/images/banner-home.png); */
    /* background-image: url(../../); */
    /* background-position: center right; */
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    @media screen and (max-width: 767px) {
      background-position: center;
    }
  }
  .video-duration-hide {
    .controls {
      .detail-controls-wrap {
        .left-wrapper {
          .video-duration {
            display: none;
          }
        }
      }
    }
  }
  .banner-section-block-inner {
    position: absolute;
    top: 50%;
    left: 0px;
    right: 0px;
    transform: translate(0, -50%);
    @media screen and (max-width: 767px) {
      top: auto;
      transform: unset;
      bottom: 50px;
    }
    .common-container {
      height: 100%;
    }
    .setting-block-inner {
      height: 100%;
      .setting-block-title {
        text-align: left;
        h3 {
          font-size: 80px;
          line-height: 100px;
          color: #fff;
          font-weight: 600;
          text-align: left;
          span {
            color: #c00;
          }
          @media screen and (max-width: 1399px) {
            font-size: 60px;
            line-height: 80px;
          }
          @media screen and (max-width: 1199px) {
            font-size: 50px;
            line-height: 70px;
          }
          @media screen and (max-width: 991px) {
            font-size: 30px;
            line-height: 45px;
          }
          @media screen and (max-width: 767px) {
            text-align: center;
            font-size: 26px;
            line-height: 36px;
          }
        }
      }
      .slick-dots {
        left: 0px;
        text-align: left;
        bottom: -100px;
        @media screen and (max-width: 1399px) {
          bottom: -80px;
        }
        @media screen and (max-width: 1199px) {
          bottom: -50px;
        }
        @media screen and (max-width: 767px) {
          right: -5px;
          bottom: -35px;
          text-align: center;
        }
        li {
          padding: 0px 5px;
          width: 12px;
          height: 12px;
          button {
            width: 10px;
            height: 10px;
            border: 1px solid #fff;
            border-radius: 50%;
            &::before {
              content: none;
            }
          }
          &.slick-active {
            button {
              width: 15px;
              height: 15px;
              background-color: #fff;
            }
          }
        }
      }
    }
  }
  .second-block {
    padding: 0px;
    .second-block-inner {
      display: flex;
      padding-top: 70px;
      align-items: center;
      position: relative;
      margin-top: -170px;
      align-items: flex-end;
      @media screen and (max-width: 991px) {
        margin-top: 0px;
        padding-top: 40px;
        flex-direction: column-reverse;
        gap: 15px;
        text-align: center;
      }
      .second-block-inner-btn {
        display: none;
        padding: 30px 0px 20px;
        @media screen and (max-width: 767px) {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          button {
            padding: 12px 20px;
            font-size: 18px;
            line-height: 18px;
            color: #fff;
            border-radius: 10px;
            background-color: #c00000;
            font-weight: 600;
            min-width: 200px;
            border: none;
          }
        }
      }
      .second-block-inner-block {
        width: 50%;
        padding: 0px 15px;
        @media screen and (max-width: 991px) {
          width: 100%;
          padding: 0px;
        }
        h2 {
          font-size: 40px;
          line-height: 60px;
          color: #000;
          font-weight: 600;
          span {
            color: #c00;
          }
          @media screen and (max-width: 1399px) {
            font-size: 30px;
            line-height: 45px;
          }
          @media screen and (max-width: 1199px) {
            font-size: 24px;
            line-height: 40px;
          }
          @media screen and (max-width: 991px) {
            font-size: 18px;
            line-height: 30px;
          }
          /* @media screen and (max-width: 767px) {
            .span-block {
              display: block;
            }
          } */
        }
      }
      .second-block-inner-block-right {
        width: 50%;
        padding: 0px 15px;
        @media screen and (max-width: 991px) {
          width: 100%;
          padding: 0px;
        }
        .second-block-inner-block-right-inner {
          /* box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04); */
          box-shadow: 4px 4px 9px 0px rgba(0, 0, 0, 0.6);
          background-color: #fff;
          padding: 35px 20px;
          border-radius: 20px;
          @media screen and (max-width: 1399px) {
            padding: 20px;
          }
          @media screen and (max-width: 767px) {
            box-shadow: 4px 4px 9px 0px rgba(0, 0, 0, 0.6);
          }
          h3 {
            font-size: 40px;
            line-height: 60px;
            color: #000;
            font-weight: 600;
            margin-bottom: 40px;
            &:last-child {
              margin: 0px;
            }
            span {
              color: #c00;
            }
            @media screen and (max-width: 1399px) {
              font-size: 30px;
              line-height: 45px;
              margin-bottom: 30px;
            }
            @media screen and (max-width: 1199px) {
              font-size: 24px;
              line-height: 40px;
              margin-bottom: 25px;
            }
            @media screen and (max-width: 991px) {
              font-size: 20px;
              line-height: 30px;
            }
            @media screen and (max-width: 767px) {
              /* text-align: left; */
            }
          }
        }
      }
    }
  }
  .one-size-block {
    padding: 70px 0px 0px;
    @media screen and (max-width: 1399px) {
      padding: 50px 0px 0px;
    }
    @media screen and (max-width: 1199px) {
      padding: 40px 0px 0px;
    }
    .img-chance-bloc {
      height: 800px;
      width: 100%;
      clip-path: inset(0);
      position: relative;
      @media screen and (max-width: 1399px) {
        height: 600px;
      }
      @media screen and (max-width: 1199px) {
        height: 500px;
      }
      @media screen and (max-width: 991px) {
        height: 450px;
      }
      @media screen and (max-width: 767px) {
        height: 400px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        background-attachment: fixed;
        position: fixed;
        left: 0;
        top: 0;
      }
    }
  }
  .common-title-block {
    text-align: center;
    margin-bottom: 50px;
    @media screen and (max-width: 1199px) {
      margin-bottom: 40px;
    }
    @media screen and (max-width: 991px) {
      margin-bottom: 30px;
    }
    h3 {
      font-size: 40px;
      line-height: 60px;
      color: #000;
      font-weight: 600;
      margin-bottom: 10px;
      span {
        color: #c00;
      }
      @media screen and (max-width: 1399px) {
        font-size: 30px;
        line-height: 45px;
      }
      @media screen and (max-width: 1199px) {
        font-size: 24px;
        line-height: 40px;
      }
      @media screen and (max-width: 991px) {
        font-size: 22px;
        line-height: 40px;
      }
    }
    p {
      font-weight: 500;
      font-size: 24px;
      line-height: 40px;
      color: #000;
      @media screen and (max-width: 1399px) {
        font-size: 20px;
        line-height: 30px;
      }
      @media screen and (max-width: 1199px) {
        font-size: 18px;
        line-height: 28px;
      }
      @media screen and (max-width: 991px) {
        font-size: 16px;
        line-height: 26px;
      }
    }
    &.mb-none-discription {
      margin-bottom: 0px;
      padding: 0px 15px;
      p {
        margin-top: 40px;
        @media screen and (max-width: 991px) {
          margin-top: 20px;
        }
        @media screen and (max-width: 991px) {
          text-align: left;
        }
        span {
          color: #c00000;
          font-weight: 600;
        }
      }
    }
  }
  .video-block {
    padding: 70px 0px 100px;
    @media screen and (max-width: 1399px) {
      padding: 50px 0px 0px;
    }
    @media screen and (max-width: 1199px) {
      padding: 40px 0px 0px;
    }
    .video-slider {
      .slick-slide {
        padding: 30px 15px;
        @media screen and (max-width: 767px) {
          padding: 30px 10px;
        }
        .video-slider {
          background-color: #fff;
          box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.05);
          width: 100%;
          /* height: 400px; */
          position: relative;
          border-radius: 20px;
          padding: 10px;
          position: relative;
          /* @media screen and (max-width: 1399px) {
            height: 350px;
          }
          @media screen and (max-width: 1199px) {
            height: 260px;
          } */
          @media screen and (max-width: 991px) {
            /* height: 220px; */
            border-radius: 10px;
          }
          @media screen and (max-width: 767px) {
            /* height: 220px; */
            border-radius: 10px;
          }
          video {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 20px;

            @media screen and (max-width: 991px) {
              border-radius: 10px;
            }
          }
        }
      }
      .slick-dots {
        text-align: center !important;
        left: 0px;
        text-align: left;
        bottom: -20px;
        right: 0px;
        @media screen and (max-width: 767px) {
          bottom: 0px;
        }
        li {
          padding: 0px 5px;
          width: 12px;
          height: 12px;
          button {
            width: 10px;
            height: 10px;
            border: 1px solid #000;
            border-radius: 50%;
            &::before {
              content: none;
            }
          }
          &.slick-active {
            button {
              width: 15px;
              height: 15px;
              background-color: #000;
            }
          }
        }
      }
    }
  }
  .video-play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: transparent;
    border: none;
    outline: none;
    box-shadow: none;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    padding: 0px;
    background-color: rgba(255, 255, 255, 0.2);
    @media screen and (max-width: 1199px) {
      width: 50px;
      height: 50px;
    }
    @media screen and (max-width: 991px) {
      width: 40px;
      height: 40px;
    }
    @media screen and (max-width: 767px) {
      width: 30px;
      height: 30px;
    }
    svg {
      width: 60px;
      height: 60px;
      @media screen and (max-width: 1199px) {
        width: 40px;
        height: 40px;
      }
      @media screen and (max-width: 991px) {
        width: 30px;
        height: 30px;
      }
      @media screen and (max-width: 767px) {
        width: 20px;
        height: 20px;
      }
    }
  }
  .about-section {
    position: relative;
    padding: 0px 0px 70px;
    @media screen and (max-width: 1399px) {
      padding: 70px 0px 50px;
    }
    @media screen and (max-width: 1199px) {
      padding: 50px 0px 40px;
    }
    .about-section-inner {
      display: flex;
      margin: 0px -15px;
      @media screen and (max-width: 991px) {
        display: block;
        margin: 0px;
      }
      .about-section-left {
        width: 50%;
        padding: 0px 15px;
        @media screen and (max-width: 991px) {
          width: 100%;
          padding: 25px 0px 0px;
        }
        .common-title-block {
          text-align: left;
          h3 {
            text-align: left;
            margin-bottom: 15px;
          }
          p {
            a {
              margin-left: 10px;
              text-decoration: underline;
              color: #c00;
              font-size: 18px;
              @media screen and (max-width: 1199px) {
                font-size: 16px;
              }
              @media screen and (max-width: 991px) {
                font-size: 14px;
              }
            }
          }
          .common-btn {
            margin-top: 15px;
            padding: 14px 25px;
            font-size: 22px;
            line-height: 22px;
            color: #fff;
            border-radius: 10px;
            background-color: #c00000;
            font-weight: 600;
            min-width: 180px;
            border: none;
            cursor: pointer;
            transition: 0.5s;
            /* &:hover {
              opacity: 0.7;
              transition: 0.5s;
            } */
            @media screen and (max-width: 1399px) {
              padding: 12px 20px;
              font-size: 20px;
              line-height: 20px;
            }
            @media screen and (max-width: 1199px) {
              font-size: 16px;
              line-height: 16px;
              min-width: 140px;
            }
          }
        }
      }
      .about-section-right {
        width: 50%;
        padding: 0px 15px;
        @media screen and (max-width: 991px) {
          width: 100%;
          padding: 0px;
        }
        .slider-section-about {
          .slick-slide {
            padding: 30px 15px;
            .video-slider {
              background-color: #fff;
              box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.05);
              width: 100%;
              height: 400px;
              position: relative;
              border-radius: 20px;
              padding: 10px;
              position: relative;
              @media screen and (max-width: 1399px) {
                height: 350px;
              }
              @media screen and (max-width: 1199px) {
                height: 260px;
              }
              @media screen and (max-width: 991px) {
                height: 220px;
                border-radius: 10px;
              }
              video {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 20px;
                @media screen and (max-width: 991px) {
                  border-radius: 10px;
                }
              }
            }
          }
          .slick-dots {
            text-align: center !important;
            left: 0px;
            text-align: left;
            bottom: -20px;
            right: 0px;
            li {
              padding: 0px 5px;
              width: 12px;
              height: 12px;
              button {
                width: 10px;
                height: 10px;
                border: 1px solid #000;
                border-radius: 50%;
                &::before {
                  content: none;
                }
              }
              &.slick-active {
                button {
                  width: 15px;
                  height: 15px;
                  background-color: #000;
                }
              }
            }
          }
        }
      }
    }
  }
  .determine-block {
    position: relative;
    height: 400px;
    @media screen and (max-width: 1399px) {
      height: 270px;
    }
    @media screen and (max-width: 1199px) {
      height: 230px;
    }
    .determine-block-img {
      height: 400px;
      width: 100%;
      clip-path: inset(0);
      position: absolute;
      top: 0px;
      @media screen and (max-width: 1399px) {
        height: 270px;
      }
      @media screen and (max-width: 1199px) {
        height: 230px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        background-attachment: fixed;
        position: fixed;
        left: 0;
        top: 0;
      }
    }
    .determine-block-text {
      position: relative;
      z-index: 9;
      padding: 75px 0px;
      text-align: center;
      @media screen and (max-width: 1399px) {
        padding: 50px 0px;
      }
      @media screen and (max-width: 1199px) {
        padding: 40px 0px;
      }
      @media screen and (max-width: 767px) {
        padding: 30px 0px;
      }
      h3 {
        font-size: 40px;
        line-height: 60px;
        color: #fff;
        font-weight: 600;
        margin-bottom: 40px;
        @media screen and (max-width: 1399px) {
          font-size: 30px;
          line-height: 45px;
          margin-bottom: 30px;
        }
        @media screen and (max-width: 1199px) {
          font-size: 24px;
          line-height: 40px;
          margin-bottom: 25px;
        }
        @media screen and (max-width: 991px) {
          font-size: 22px;
          line-height: 40px;
          br {
            display: none;
          }
        }
      }
      .common-btn {
        padding: 14px 25px;
        font-size: 24px;
        line-height: 24px;
        color: #fff;
        border-radius: 10px;
        background-color: #c00000;
        font-weight: 600;
        min-width: 200px;
        border: none;
        @media screen and (max-width: 1399px) {
          padding: 12px 20px;
          font-size: 20px;
          line-height: 20px;
        }
        @media screen and (max-width: 1199px) {
          font-size: 18px;
          line-height: 18px;
        }
      }
    }
  }
  .goal-block {
    padding: 70px 0px;
    @media screen and (max-width: 1399px) {
      padding: 50px 0px;
    }
    @media screen and (max-width: 1199px) {
      padding: 40px 0px;
    }
    .goal-block-img {
      > img {
        width: 100%;
        height: auto;
      }
      .goal-block-img {
        width: 50%;
        margin: 40px auto 0px;
        /* height: 400px; */
        height: auto;
        border-radius: 20px;
        position: relative;
        background-color: #fff;
        box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.05);
        padding: 10px;
        @media screen and (max-width: 1199px) {
          width: 100%;
          margin: 30px auto 0px;
        }
        /* @media screen and (max-width: 767px) {
          height: 260px;
        } */
        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 20px;
        }
      }
    }
  }
  .receive-block {
    padding: 70px 0px;
    @media screen and (max-width: 1399px) {
      padding: 50px 0px;
    }
    @media screen and (max-width: 1199px) {
      padding: 40px 0px 50px;
    }
    @media screen and (max-width: 767px) {
      padding: 40px 10px 50px;
    }
    .receive-block-inner {
      display: flex;
      gap: 15px;
      @media screen and (max-width: 991px) {
        display: block;
      }
      .receive-block-inner-left {
        width: 50%;
        @media screen and (max-width: 991px) {
          width: 100%;
        }
        h3 {
          font-size: 40px;
          text-align: left;
          line-height: 60px;
          color: #000;
          font-weight: 600;
          margin-bottom: 40px;
          @media screen and (max-width: 1399px) {
            font-size: 30px;
            line-height: 45px;
            margin-bottom: 30px;
          }
          @media screen and (max-width: 1199px) {
            font-size: 24px;
            line-height: 40px;
            margin-bottom: 25px;
          }
          span {
            color: #c00;
          }
        }
        .programe-block {
          h4 {
            font-size: 30px;
            text-align: left;
            line-height: 40px;
            color: #000;
            font-weight: 600;
            margin-bottom: 25px;
            span {
              color: #c00;
            }
            @media screen and (max-width: 1399px) {
              font-size: 22px;
              line-height: 32px;
              margin-bottom: 20px;
            }
            @media screen and (max-width: 1199px) {
              font-size: 20px;
              line-height: 30px;
              margin-bottom: 15px;
            }
          }
          ul {
            padding: 0px;
            list-style: none;
            margin: 0px 0px 35px;

            li {
              position: relative;
              font-weight: 500;
              font-size: 20px;
              line-height: 30px;
              color: #000;
              margin-bottom: 25px;
              position: relative;
              display: flex;
              align-items: center;
              img {
                margin-right: 10px;
                @media screen and (max-width: 1399px) {
                  width: 24px;
                }
              }
              &::before {
                content: "";
                position: absolute;
                left: 0px;
              }
              @media screen and (max-width: 1399px) {
                font-size: 18px;
                line-height: 28px;
                margin-bottom: 15px;
              }
              @media screen and (max-width: 1199px) {
                font-size: 16px;
                line-height: 26px;
              }
            }
          }
        }
        .learm-more-link {
          a {
            text-decoration: underline;
            color: #c00;
            font-size: 18px;
          }
          .common-btn {
            padding: 14px 25px;
            font-size: 22px;
            line-height: 22px;
            color: #fff;
            border-radius: 10px;
            background-color: #c00000;
            font-weight: 600;
            min-width: 180px;
            border: none;
            cursor: pointer;
            transition: 0.5s;
            /* &:hover {
              opacity: 0.7;
              transition: 0.5s;
            } */
            @media screen and (max-width: 1399px) {
              padding: 12px 20px;
              font-size: 20px;
              line-height: 20px;
            }
            @media screen and (max-width: 1199px) {
              font-size: 16px;
              line-height: 16px;
              min-width: 140px;
            }
          }
        }
      }
      .receive-block-inner-right {
        width: 50%;
        @media screen and (max-width: 991px) {
          width: 100%;
          padding-top: 25px;
        }
        .slick-dots {
          text-align: center !important;
          left: 0px;
          text-align: left;
          bottom: -20px;
          right: 0px;
          /* @media screen and (max-width: 767px) {
          bottom: 0px;
          } */
          li {
            padding: 0px 5px;
            width: 12px;
            height: 12px;
            button {
              width: 10px;
              height: 10px;
              border: 1px solid #000;
              border-radius: 50%;
              &::before {
                content: none;
              }
            }
            &.slick-active {
              button {
                width: 15px;
                height: 15px;
                background-color: #000;
              }
            }
          }
        }
        .receive-block-inner-right-top {
          text-align: center;
          img {
            max-width: 600px;
            margin: 0 auto;
            @media screen and (max-width: 1399px) {
              max-width: 100%;
            }
          }
        }
        .receive-block-inner-right-bottom {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          gap: 0px;
          margin: 30px auto;
          flex-wrap: wrap;
          @media screen and (max-width: 1399px) {
            width: 100%;
            margin: 20px auto;
          }
          .receive-block-inner-right-bottom-inner {
            width: 50%;
            padding: 0px 10px 20px;
            @media screen and (max-width: 767px) {
              width: 100%;
            }
            .receive-block-video {
              width: 100%;
              /* height: 200px; */
              background-color: #fff;
              box-shadow: 0px 10px 10px 2px rgba(0, 0, 0, 0.05);
              border-radius: 20px;
              padding: 5px;
              position: relative;
              @media screen and (max-width: 1399px) {
                /* height: 170px; */
                border-radius: 10px;
              }
              video {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 20px;
                @media screen and (max-width: 1399px) {
                  border-radius: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
  .testimonial-block {
    /* padding: 70px 0px; */
    position: relative;
    /* @media screen and (max-width: 1300px) {
      display: none;
    } */
    .testimonial-block-inner {
      display: flex;
      height: 550px;
      /* background: linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(0, 0, 0, 1) 35%, rgba(51, 51, 51, 1) 100%); */
      @media screen and (max-width: 1399px) {
        height: 450px;
      }
      @media screen and (max-width: 1199px) {
        height: 400px;
      }
      @media screen and (max-width: 767px) {
        height: auto;
        flex-direction: column-reverse;
      }
      .testimonial-block-inner-left {
        width: 50%;
        height: 100%;
        background: linear-gradient(
          90deg,
          rgba(2, 0, 36, 1) 0%,
          rgba(0, 0, 0, 1) 35%,
          rgba(51, 51, 51, 1) 100%
        );
        @media screen and (max-width: 767px) {
          width: 100%;
        }
        .testimonial-content {
          /* padding-left: 13%; */
          padding: 50px 50px 50px 10%;
          @media screen and (max-width: 1399px) {
            padding: 50px 15px 15px;
          }
          @media screen and (max-width: 1199px) {
            padding: 40px 15px 80px;
          }
          @media screen and (max-width: 991px) {
            height: 450px;
          }
        }
      }
      .testimonial-block-inner-right {
        width: 50%;
        height: 100%;
        @media screen and (max-width: 767px) {
          width: 100%;
          height: 300px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .testimonial-block-data {
      /* position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      z-index: 9; */
      .testimonial-width {
        width: 100%;
        /* padding: 40px 40px 40px 0px; */
        position: relative;
        h2 {
          font-size: 40px;
          text-align: left;
          line-height: 60px;
          color: #fff;
          font-weight: 600;
          margin-bottom: 30px;
          /* left: 5%; */
          right: 0px;
          /* z-index: 9; */
          /* margin: 0px; */
          /* top: 50px; */
          /* position: absolute; */
          @media screen and (max-width: 1399px) {
            font-size: 30px;
            line-height: 45px;
            margin-bottom: 15px;
          }
          @media screen and (max-width: 1199px) {
            font-size: 24px;
            line-height: 40px;
          }
          @media screen and (max-width: 991px) {
            font-size: 22px;
            line-height: 40px;
          }
        }
        p {
          font-weight: 500;
          font-size: 24px;
          line-height: 40px;
          color: #fff;
          /* display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 160px; */
          @media screen and (max-width: 1399px) {
            font-size: 20px;
            line-height: 30px;
            height: 130px;
          }
          @media screen and (max-width: 1199px) {
            font-size: 18px;
            line-height: 32px;
          }
          @media screen and (max-width: 991px) {
            font-size: 16px;
            line-height: 28px;
          }
          @media screen and (max-width: 991px) {
            display: -webkit-box;
            -webkit-line-clamp: 6;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            height: 160px;
          }
        }
        h5 {
          font-weight: 500;
          font-size: 24px;
          line-height: 40px;
          color: #fff;
          text-align: right;
          margin-top: 25px;
          @media screen and (max-width: 1399px) {
            font-size: 20px;
            line-height: 30px;
            margin-top: 15px;
          }
          @media screen and (max-width: 1199px) {
            font-size: 18px;
            line-height: 32px;
          }
          @media screen and (max-width: 991px) {
            font-size: 16px;
            line-height: 28px;
          }
        }
      }
      .slick-dots {
        left: 5%;
        text-align: left;
        bottom: 60px;
        @media screen and (max-width: 1399px) {
          left: 15px;
        }
        @media screen and (max-width: 767px) {
          bottom: 30px;
        }
        li {
          padding: 0px 5px;
          width: 12px;
          height: 12px;
          button {
            width: 10px;
            height: 10px;
            border: 1px solid #fff;
            border-radius: 50%;
            &::before {
              content: none;
            }
          }
          &.slick-active {
            button {
              width: 15px;
              height: 15px;
              background-color: #fff;
            }
          }
        }
      }
    }
  }
  .testimonial-block-last {
    padding: 70px 0px 70px;
    position: relative;
    @media screen and (max-width: 1399px) {
      padding: 50px 0px;
    }
    @media screen and (max-width: 1199px) {
      padding: 40px 0px;
    }
    .testimonial-block-last-inner {
      /* display: flex;
      margin: 0px -15px; */
      .testimonial-block-box {
        width: 100%;
        padding: 100px 15px 30px;
        .testimonial-block-box-inner {
          background-color: #fff;
          box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.05);
          border-radius: 20px;
          padding: 20px;
          position: relative;
          text-align: center;
          @media screen and (max-width: 1399px) {
            border-radius: 10px;
            padding: 15px;
          }
          .testimonial-img {
            width: 200px;
            height: 200px;
            border-radius: 50%;
            /* object-fit: cover; */
            border: 2px solid #c00;
            margin: -100px auto 15px;
            @media screen and (max-width: 1399px) {
              width: 150px;
              height: 150px;
            }
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
            }
          }
          p {
            font-weight: 500;
            font-size: 24px;
            line-height: 40px;
            color: #000;
            text-align: center;
            margin-bottom: 10px;
            @media screen and (max-width: 1399px) {
              font-size: 18px;
              line-height: 30px;
            }
          }
          h6 {
            font-weight: 500;
            font-size: 18px;
            line-height: 30px;
            color: #000;
            text-align: center;
            margin-bottom: 15px;
            @media screen and (max-width: 1399px) {
              font-size: 16px;
              line-height: 26px;
            }
          }
          ul {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            @media screen and (max-width: 1399px) {
              gap: 5px;
              img {
                width: 25px;
              }
            }
          }
        }
      }
    }
    .slick-dots {
      text-align: center !important;
      left: 0px;
      text-align: left;
      bottom: -20px;
      right: 0px;
      li {
        padding: 0px 5px;
        width: 12px;
        height: 12px;
        button {
          width: 10px;
          height: 10px;
          border: 1px solid #000;
          border-radius: 50%;
          &::before {
            content: none;
          }
        }
        &.slick-active {
          button {
            width: 15px;
            height: 15px;
            background-color: #000;
          }
        }
      }
    }
  }
  .step-block {
    padding: 100px 0px 0px;
    @media screen and (max-width: 1399px) {
      padding: 50px 0px;
    }
    @media screen and (max-width: 1199px) {
      padding: 40px 0px;
    }
    @media screen and (max-width: 767px) {
      padding: 40px 0px 0px;
    }
    .common-container {
      @media screen and (max-width: 1800px) {
        &.step-block-container {
          max-width: 1300px;
        }
      }
      @media screen and (max-width: 1300px) {
        &.step-block-container {
          max-width: 950px;
        }
      }
      @media screen and (max-width: 991px) {
        &.step-block-container {
          max-width: 100%;
        }
      }
    }
    .common-title-block {
      text-align: left;
      h3 {
        text-align: left;
      }
    }
    .step-block-inner {
      padding: 0px 130px;
      @media screen and (max-width: 1800px) {
        padding: 0px 100px;
      }
      @media screen and (max-width: 1300px) {
        padding: 0px 15px;
      }
      .common-step-block {
        padding-bottom: 80px;
        position: relative;
        display: flex;
        align-items: center;
        @media screen and (max-width: 1800px) {
          padding-bottom: 50px;
        }
        @media screen and (max-width: 767px) {
          padding-bottom: 0px;
          height: 150px;
          align-items: flex-start;
        }
        .round-block {
          width: 200px;
          height: 200px;
          border-radius: 50%;
          background-color: #c00;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          /* z-index: 9; */
          @media screen and (max-width: 1800px) {
            width: 130px;
            height: 130px;
          }
          @media screen and (max-width: 1300px) {
            width: 100px;
            height: 100px;
          }
          @media screen and (max-width: 767px) {
            width: 80px;
            height: 80px;
          }
          h4 {
            font-size: 30px;
            font-weight: 600;
            color: #fff;
            text-transform: uppercase;
            @media screen and (max-width: 1800px) {
              font-size: 24px;
              font-weight: 600;
            }
            @media screen and (max-width: 1300px) {
              font-size: 20px;
              font-weight: 600;
            }
            @media screen and (max-width: 991px) {
              font-size: 18px;
              line-height: 24px;
            }
            @media screen and (max-width: 767px) {
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
        ol {
          padding: 0px 0px 0px 60px;
          width: 40%;
          margin: 0px;
          @media screen and (max-width: 1800px) {
            width: 70%;
          }
          @media screen and (max-width: 991px) {
            width: 90%;
            padding: 0px 0px 0px 40px;
          }
          @media screen and (max-width: 767px) {
            width: 80%;
          }
          li {
            color: rgba(0, 0, 0, 0.8);
            font-size: 24px;
            line-height: 36px;
            font-weight: 400;
            margin: 0px;
            @media screen and (max-width: 1800px) {
              font-size: 20px;
              line-height: 30px;
            }
            @media screen and (max-width: 991px) {
              font-size: 18px;
              line-height: 28px;
            }
            @media screen and (max-width: 767px) {
              font-size: 16px;
              line-height: 26px;
            }
          }
        }
        &.step-block-inner-first {
          &:after {
            content: "";
            position: absolute;
            bottom: 40px;
            width: 1px;
            height: 40px;
            background-color: #000;
            left: 98px;
            right: 0px;
            @media screen and (max-width: 1800px) {
              left: 65px;
              bottom: 25px;
              height: 25px;
            }
            @media screen and (max-width: 1300px) {
              left: 50px;
              bottom: 25px;
              height: 25px;
            }
            @media screen and (max-width: 991px) {
              left: 48px;
              bottom: 0px;
              height: 51px;
            }
            @media screen and (max-width: 767px) {
              left: 38px;
              bottom: 0px;
              height: 71px;
            }
          }
          &::before {
            content: "";
            position: absolute;
            bottom: 40px;
            width: 333px;
            height: 1px;
            background-color: #000;
            left: 98px;
            right: 0px;
            @media screen and (max-width: 1800px) {
              left: 65px;
              bottom: 25px;
              width: 93px;
            }
            @media screen and (max-width: 1300px) {
              left: 50px;
              bottom: 25px;
              width: 83px;
            }
            @media screen and (max-width: 991px) {
              content: none;
            }
          }
        }
        &.step-block-inner-second {
          justify-content: center;
          @media screen and (max-width: 991px) {
            justify-content: flex-start;
          }
          .round-block {
            position: relative;
            &:after {
              content: "";
              position: absolute;
              bottom: -40px;
              width: 1px;
              height: 280px;
              background-color: #000;
              left: 98px;
              right: 0px;
              z-index: -8;
              @media screen and (max-width: 1800px) {
                bottom: -30px;
                height: 185px;
                left: 61px;
              }
              @media screen and (max-width: 1300px) {
                bottom: -30px;
                height: 155px;
                left: 48px;
              }
              @media screen and (max-width: 991px) {
                left: 48px;
                bottom: -50px;
                height: 51px;
              }
              @media screen and (max-width: 767px) {
                left: 38px;
                bottom: -80px;
                height: 81px;
              }
            }
            &::before {
              content: "";
              position: absolute;
              bottom: -40px;
              width: 333px;
              height: 1px;
              background-color: #000;
              left: 98px;
              right: 0px;
              @media screen and (max-width: 1800px) {
                bottom: -30px;
                width: 93px;
                left: 61px;
              }
              @media screen and (max-width: 1300px) {
                bottom: -30px;
                width: 83px;
                left: 49px;
              }
              @media screen and (max-width: 991px) {
                content: none;
              }
            }
          }
          ol {
            li {
              &:nth-child(1) {
                list-style: none;
              }
            }
          }
        }
        &.step-block-inner-third {
          justify-content: flex-end;
          @media screen and (max-width: 767px) {
            justify-content: flex-start;
          }
          .round-block {
            position: relative;
            &:after {
              content: "";
              position: absolute;
              top: -40px;
              width: 1px;
              height: 40px;
              background-color: #000;
              left: 98px;
              right: 0px;
              z-index: -8;
              @media screen and (max-width: 1800px) {
                top: -21px;
                left: 59px;
                height: 40px;
              }
              @media screen and (max-width: 1300px) {
                top: -21px;
                left: 49px;
                height: 40px;
              }
              @media screen and (max-width: 991px) {
                content: none;
              }
            }
          }
          ol {
            li {
              &:nth-child(1),
              &:nth-child(2) {
                list-style: none;
              }
            }
          }
        }
      }
    }
  }
  .about-main-learn-main {
    .about-main-learn-main-height-full {
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 50px;
      /* @media screen and (min-width: 2200px) {
        justify-content: center;
      } */
      &.diff-center-block {
        justify-content: center;
      }
      @media screen and (max-width: 767px) {
        height: auto;
      }
      @media screen and (max-height: 770px) {
        height: auto;
      }
      .common-padding-about {
        padding-top: 50px;
        @media screen and (max-width: 1500px) {
          padding-top: 40px;
        }
        @media screen and (max-width: 1199px) {
          padding-top: 50px;
        }
      }
    }
    .breadcrumb-block {
      padding-left: 0px;
    }
    .common-banner-block {
      position: relative;
      .main-banner {
        width: 100%;
        height: 210px;

        @media screen and (max-width: 1399px) {
          height: 180px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .common-banner-block-inner {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        left: 0px;
        right: 0px;
        @media screen and (max-width: 767px) {
          text-align: center;
          padding: 0px 5px;
        }
        h1 {
          font-weight: 600;
          font-size: 55px;
          line-height: 55px;
          color: #fff;
          @media screen and (max-width: 1399px) {
            font-size: 45px;
            line-height: 50px;
          }
        }

        p {
          color: #fff;
          margin-top: 15px;
          font-size: 18px;
          line-height: 24px;
          @media screen and (max-width: 1399px) {
            font-size: 16px;
            line-height: 22px;
          }
          @media screen and (max-width: 991px) {
            margin-top: 5px;
          }
        }
        .theme-diff-btn-block {
          margin-top: 15px;
          padding: 12px;
          font-size: 20px;
          line-height: 20px;
          color: #fff;
          border-radius: 10px;
          background-color: #c00000;
          font-weight: 700;
          min-width: 200px;
          /* &:hover {
          background-color: #000;
        } */
          @media screen and (max-width: 767px) {
            margin-top: 5px;
            padding: 10px;
            font-size: 14px;
            line-height: 14px;
            min-width: 160px;
          }
        }
      }
    }
    .common-padding-about {
      padding-top: 100px;
      @media screen and (max-width: 1500px) {
        padding-top: 40px;
      }
      @media screen and (max-width: 1199px) {
        padding-top: 50px;
      }
    }
    h2 {
      font-size: 40px;
      line-height: 60px;
      color: #000;
      font-weight: 600;
      margin-bottom: 40px;
      text-align: left;
      &.theme-color {
        color: #c00000;
      }
      @media screen and (max-width: 1399px) {
        font-size: 30px;
        line-height: 40px;
        margin-bottom: 30px;
      }
      @media screen and (max-width: 1199px) {
        font-size: 26px;
        line-height: 36px;
        margin-bottom: 25px;
      }
      @media screen and (max-width: 991px) {
        font-size: 24px;
        line-height: 30px;
      }
      @media screen and (max-width: 767px) {
        font-size: 22px;
        line-height: 28px;
      }
    }
    h3 {
      font-size: 30px;
      line-height: 40px;
      color: #000;
      font-weight: 600;
      margin-bottom: 25px;
      text-align: left;
      span {
        color: #c00000;
      }
      @media screen and (max-width: 1399px) {
        font-size: 26px;
        line-height: 32px;
        margin-bottom: 25px;
      }
      @media screen and (max-width: 1199px) {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 20px;
      }
      @media screen and (max-width: 991px) {
        font-size: 20px;
        line-height: 26px;
      }
      @media screen and (max-width: 767px) {
        font-size: 18px;
        line-height: 26px;
      }
    }
    p {
      font-size: 20px;
      line-height: 30px;
      color: #000;
      font-weight: 400;
      span {
        color: #c00000;
        &.text-blue {
          color: #0342b6;
        }
      }
      @media screen and (max-width: 1399px) {
        font-size: 18px;
        line-height: 24px;
      }
      @media screen and (max-width: 1199px) {
        font-size: 16px;
        line-height: 22px;
      }
      @media screen and (max-width: 991px) {
        font-size: 14px;
        line-height: 20px;
      }
    }
    ul {
      list-style: disc;
      padding-left: 14px;
      li {
        font-size: 20px;
        line-height: 30px;
        color: #000;
        font-weight: 400;
        margin-bottom: 10px;
        @media screen and (max-width: 1399px) {
          font-size: 18px;
          line-height: 24px;
        }
        @media screen and (max-width: 1199px) {
          font-size: 16px;
          line-height: 22px;
        }
        @media screen and (max-width: 991px) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
    .about-top {
      @media screen and (max-width: 767px) {
        padding-top: 30px;
      }
      .about-top-inner {
        display: flex;
        margin: 0px -15px;
        @media screen and (max-width: 767px) {
          flex-direction: column-reverse;
        }
        .about-top-inner-left {
          width: 60%;
          padding: 0px 15px;
          @media screen and (max-width: 1199px) {
            width: 50%;
          }
          @media screen and (max-width: 767px) {
            width: 100%;
          }
        }
        .about-top-inner-right {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            max-width: 100%;
            width: 200px;
            @media screen and (min-height: 1500px) {
              width: 400px !important;
            }
            @media screen and (min-width: 2200px) {
              width: 350px;
            }
            @media screen and (max-width: 1500px) {
              width: 150px;
            }
            @media screen and (max-width: 1199px) {
              width: 200px;
            }
            @media screen and (max-width: 991px) {
              width: 150px;
            }
            @media screen and (max-width: 767px) {
              width: 100%;
            }
          }
          @media screen and (max-width: 767px) {
            width: 100%;
            margin-bottom: 25px;
            img {
              width: 100%;
            }
          }
        }
      }
      &.about-top-second {
        padding-top: 30px;
        .about-top-inner {
          display: flex;
          margin: 0px;

          .about-top-inner-left {
            width: 50%;
            padding: 0px 15px;
            @media screen and (max-width: 767px) {
              width: 100%;
              text-align: left;
              .theme-color {
                text-align: left !important;
              }
            }
          }
        }
      }
    }
    .about-take-assign {
      .about-take-assign-inner {
        display: flex;
        align-items: center;
        margin: 0px -15px;
        .about-take-assign-inner-block {
          width: 33.33%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0px 15px;
          @media screen and (max-width: 1199px) {
            width: 50%;
            img {
              width: 100%;
            }
          }
          img {
            max-width: 100%;
            width: 200px;
            @media screen and (min-height: 1500px) {
              width: 400px !important;
            }
            @media screen and (min-width: 2200px) {
              width: 350px;
            }
            @media screen and (max-width: 1500px) {
              width: 150px;
            }
            @media screen and (max-width: 1199px) {
              width: 200px;
            }
            @media screen and (max-width: 991px) {
              width: 150px;
            }
            @media screen and (max-width: 767px) {
              width: 100%;
            }
          }
        }
      }
      .about-new-btn {
        padding-top: 30px;
        margin: 0 auto;
        display: table;
        @media screen and (max-width: 1399px) {
          padding-top: 50px;
        }
        @media screen and (max-width: 1199px) {
          padding-top: 30px;
        }
        .common-btn {
          padding: 14px 25px;
          font-size: 24px;
          line-height: 24px;
          color: #fff;
          border-radius: 10px;
          background-color: #c00000;
          font-weight: 600;
          min-width: 200px;
          border: none;
          cursor: pointer;
          @media screen and (max-width: 1399px) {
            padding: 12px 20px;
            font-size: 20px;
            line-height: 20px;
          }
          @media screen and (max-width: 1199px) {
            font-size: 16px;
            line-height: 16px;
          }
        }
      }
    }
    .about-take-assign-second {
      @media screen and (max-width: 767px) {
        padding-top: 20px !important;
      }
      .common-container {
        max-width: 1230px !important;
        @media screen and (min-width: 2400px) {
          max-width: 1600px !important;
        }
      }
      .about-take-assign-second-flex {
        display: flex;
        margin: 0 -15px;
        @media screen and (max-width: 767px) {
          /* display: block; */
        }
        .about-take-assign-second-flex-inner {
          width: 50%;
          text-align: center;
          padding: 0px 15px;
          @media screen and (max-width: 767px) {
            width: 100%;
            margin-bottom: 5px;
          }
          img {
            max-width: 100%;
            width: 190px;
            height: 290px;
            object-fit: contain;
            @media screen and (min-height: 1500px) {
              width: 700px !important;
              height: 700px !important;
            }
            @media screen and (min-height: 1000px) {
              width: 470px;
              height: 470px;
            }
            @media screen and (min-height: 950px) {
              width: 410px;
              height: 410px;
            }
            @media screen and (min-width: 2200px) {
              width: 350px;
              height: 410px;
            }
            @media screen and (max-width: 1199px) {
              width: 180px;
            }
            @media screen and (max-width: 991px) {
              width: 150px;
            }
            @media screen and (max-width: 767px) {
              width: 260px;
              height: 220px;
            }
          }
          p {
            max-width: 450px;
            margin: 15px auto 0px;
            font-size: 16px;
            line-height: 26px;
            text-align: left;
            @media screen and (min-width: 2500px) {
              font-size: 20px;
              line-height: 30px;
            }
            @media screen and (max-width: 1399px) {
              width: 100%;
              margin: 20px auto 0px;
            }
            @media screen and (max-width: 767px) {
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
      }
    }
    .about-round-block {
      @media screen and (max-width: 767px) {
        padding-top: 20px !important;
      }
      .about-round-block-inner {
        display: flex;
        padding: 0px 100px;
        justify-content: center;
        gap: 280px;
        @media screen and (max-width: 1599px) {
          gap: 200px;
        }
        @media screen and (max-width: 991px) {
          gap: 250px;
        }
        @media screen and (max-width: 767px) {
          /* flex-direction: column;
          gap: 50px;
          padding: 0px 0px;
          justify-content: center;
          margin: 0 auto;
          display: table; */
          padding: 0px 0px;
          justify-content: space-between;
          gap: 0px;
        }
        .about-round-block-inner-text {
          /* margin: 0px 100px; */
          width: 320px;
          height: 300px;
          border-radius: 50%;
          background-color: #000;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px;
          position: relative;
          @media screen and (min-height: 1500px) {
            width: 520px;
            height: 500px;
          }
          @media screen and (max-width: 1599px) {
            /* width: 360px;
            height: 360px; */
            padding: 20px;
          }
          @media screen and (max-width: 1399px) {
            /* width: 340px;
            height: 340px; */
            padding: 20px;
          }
          @media screen and (max-width: 1199px) {
            width: 300px;
            height: 280px;
            padding: 20px;
          }
          @media screen and (max-width: 991px) {
            width: 185px;
            height: 170px;
            padding: 20px;
          }
          @media screen and (max-width: 767px) {
            width: 140px;
            height: 150px;
            padding: 20px;
          }
          &:last-child {
            background-color: #c00000;
            @media screen and (max-width: 767px) {
              /* margin-top: 70px; */
              &:before {
                left: -160%;
                width: 450px;
                right: 0;
              }
            }
            @media screen and (max-width: 620px) {
              /* margin-top: 70px; */
              &:before {
                left: -140%;
                width: 390px;
                right: 0;
              }
            }
            @media screen and (max-width: 550px) {
              /* margin-top: 70px; */
              &:before {
                width: 240px;
                left: -86%;
              }
            }
            @media screen and (max-width: 400px) {
              /* margin-top: 70px; */
              &:before {
                width: 170px;
                left: -60%;
              }
            }
          }
          &:first-child {
            &::before {
              content: none;
            }
          }
          &::before {
            content: "";
            position: absolute;
            /* left: -100px;
            width: 200px; */
            left: -150px;
            width: 300px;
            top: 50%;
            transform: translate(-50%, 0);
            background-color: #000;
            /* right: 0px; */
            /* width: 1px; */
            height: 1px;
          }
          p {
            color: #fff;
            font-size: 22px;
            line-height: 34px;
            text-align: center;
            position: relative;
            z-index: 9;
            /* @media screen and (max-width: 1599px) {
              font-size: 22px;
              line-height: 30px;
            } */
            @media screen and (max-width: 1199px) {
              font-size: 20px;
              line-height: 30px;
            }
            @media screen and (max-width: 991px) {
              font-size: 14px;
              line-height: 20px;
            }
            @media screen and (max-width: 991px) {
              font-size: 13px;
              line-height: 18px;
            }
            @media screen and (max-width: 767px) {
              font-size: 10px;
              line-height: 15px;
            }
            @media screen and (min-height: 1500px) {
              font-size: 32px;
              line-height: 50px;
            }
          }
        }
      }
    }
    .determine-block {
      /* margin-top: 100px; */
      /* @media screen and (max-width: 1399px) {
        margin-top: 70px;
      }
      @media screen and (max-width: 1199px) {
        margin-top: 50px;
      } */
      h3 {
        text-align: center;
      }
    }
    .body-type-block {
      height: 100vh;
      padding-bottom: 50px;
      padding-top: 50px;
      @media screen and (min-height: 1500px) {
        height: auto;
      }
      @media screen and (max-width: 767px) {
        height: auto;
        padding-bottom: 0px;
        padding-top: 30px;
      }
      @media screen and (max-height: 770px) {
        height: auto;
      }
      .common-container {
        max-width: 1230px !important;

        /* .body-type-block-inner {
          height: 100%;
          .body-type-block-inner-flex {
            height: 100%;
          }
        } */
      }
      .common-title-block {
        h3 {
          text-align: center;
        }
      }
      .body-type-img {
        height: calc(100vh - 230px);
        @media screen and (max-height: 850px) {
          height: calc(100vh - 270px);
        }
        @media screen and (min-height: 1500px) {
          height: auto;
        }
        @media screen and (max-width: 767px) {
          height: auto;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          @media screen and (max-width: 767px) {
            height: auto;
          }
          @media screen and (min-height: 950px) {
            height: auto;
            object-fit: unset;
          }
        }
        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .body-type-block-inner {
        display: flex;
        margin: 0px 0px;
        /* @media screen and (max-width: 1399px) {
          margin: 0px -00 30px;
        }
        @media screen and (max-width: 991px) {
          margin: 0px -5px 25px;
        } */

        .body-type-block-inner-flex {
          padding: 0px 25px 0px 0px;
          width: 23.3%;
          /* text-align: center; */
          text-align: left;
          margin: 0 auto;
          display: table;
          /* @media screen and (max-width: 1399px) {
            padding: 0px 15px;
          } */
          @media screen and (max-width: 991px) {
            padding: 0px 5px 0px 0px;
          }
          &:last-child {
            width: 30%;
          }
          h4 {
            font-size: 16px;
            line-height: 24px;
            color: #c00000;
            font-weight: 600;
            margin-bottom: 5px;
            text-align: center;
            @media screen and (max-width: 1399px) {
              font-size: 20px;
              line-height: 30px;
              margin-bottom: 5px;
            }
            @media screen and (max-width: 991px) {
              font-size: 16px;
              line-height: 24px;
              margin-bottom: 5px;
            }
            @media screen and (max-width: 767px) {
              font-size: 16px;
              line-height: 20px;
            }
            @media screen and (max-width: 767px) {
              font-size: 8px;
              line-height: 12px;
            }
          }

          p {
            font-size: 16px;
            @media screen and (max-width: 991px) {
              font-size: 7px;
              line-height: 11px;
            }
          }
          ul {
            li {
              text-align: left;
              font-size: 14px;
              margin-bottom: 3px;
              line-height: 16px;
              @media screen and (max-width: 991px) {
                font-size: 7px;
                line-height: 8px;
              }
            }
          }
          .body-type-block-inner-flex-content {
            margin-bottom: 10px;
          }
          .body-type-block-inner-flex-img {
            height: calc(100vh - 250px);
            @media screen and (max-width: 767px) {
              height: auto;
            }
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              @media screen and (max-width: 767px) {
                height: auto;
              }
            }
          }
        }
      }
    }
    .goal-block {
      .common-title-block {
        h3 {
          text-align: center;
        }
      }
    }
    .video-block {
      position: relative;
      padding: 100px 0px 100px 0px;
      @media screen and (max-width: 1399px) {
        padding-top: 70px;
        padding-bottom: 70px;
      }
      @media screen and (max-width: 1199px) {
        padding-top: 50px;
        padding-bottom: 50px;
      }
      h3 {
        text-align: center;
      }
      .video-slider-flex {
        display: flex;
        margin: 0 -15px;
        &.video-slider-flex-flex {
          display: block;
          margin: 0px;
          /* .video-slider-flex-inner {
            padding: 0px;
          } */
        }
        .slick-dots {
          left: 0px;
          text-align: center;
          bottom: -50px;
          padding: 0px;
          @media screen and (max-width: 1399px) {
            bottom: -50px;
          }
          @media screen and (max-width: 1199px) {
            bottom: -40px;
          }
          @media screen and (max-width: 767px) {
            right: 0;
            bottom: -40px;
            text-align: center;
          }
          li {
            padding: 0px 5px;
            width: 12px;
            height: 12px;
            button {
              width: 10px;
              height: 10px;
              border: 1px solid #000;
              border-radius: 50%;
              &::before {
                content: none;
              }
            }
            &.slick-active {
              button {
                width: 15px;
                height: 15px;
                background-color: #000;
              }
            }
          }
        }
        @media screen and (max-width: 767px) {
          display: block;
          margin: 0px;
        }
        .video-slider-flex-inner {
          width: 33.33%;
          padding: 0px 15px;
          @media screen and (max-width: 767px) {
            width: 100%;
            /* padding: 0px 0px 15px; */
            .video-slider {
              .video-player {
                .controls {
                  .detail-controls-wrap {
                    .video-duration {
                      font-size: 12px !important;
                    }
                    button {
                      margin-right: 1px;
                    }
                    .sound-controls {
                      padding: 2px 1px;
                    }
                  }
                }
              }
            }
          }
          &.full-height-block {
            height: 100%;
            .video-player {
              height: 100%;
              .class-hidden-controls {
                object-fit: contain;
              }
            }
          }
          .video-slider {
            background-color: #fff;
            box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.05);
            width: 100%;
            height: 400px;
            position: relative;
            border-radius: 20px;
            padding: 10px;
            position: relative;
            @media screen and (max-width: 1399px) {
              height: 350px;
            }
            @media screen and (max-width: 1199px) {
              height: 260px;
            }
            @media screen and (max-width: 991px) {
              height: 180px;
              border-radius: 10px;
            }
            @media screen and (max-width: 767px) {
              height: 220px;
              border-radius: 10px;
            }
            @media screen and (max-width: 767px) {
              height: auto;
            }
            video {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 20px;
              @media screen and (max-width: 991px) {
                border-radius: 10px;
              }
            }
          }
        }
      }
    }
    .trigger-block {
      position: relative;
      .flex-block-data {
        display: flex;
        align-items: center;
        gap: 40px;
        @media screen and (max-width: 991px) {
          display: block;
        }
        .flex-block-data-inner {
          width: 20%;
          background-color: #fff;
          box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
          border-radius: 20px;
          font-family: "Mulish", serif;
          padding: 20px;
          @media screen and (max-width: 991px) {
            padding: 15px;
            width: 100%;
            margin-bottom: 25px;
          }
          p {
            margin-bottom: 35px;
            color: #000;
            font-weight: 600;
            font-size: 18px;
            line-height: 36px;
            @media screen and (max-width: 1399px) {
              font-size: 16px;
              line-height: 30px;
              margin-bottom: 20px;
            }
            @media screen and (max-width: 1199px) {
              font-size: 14px;
              line-height: 26px;
              margin-bottom: 15px;
            }
            &:last-child {
              margin: 0px;
            }
            svg {
              width: 20px;
              position: relative;
              top: -2px;
            }
          }
        }
      }
      .common-title-block {
        text-align: center;
        @media screen and (max-width: 991px) {
          margin: 0px;
        }

        h3 {
          text-align: center;
          font-size: 40px;
          line-height: 60px;
          color: #000;
          font-weight: 600;
          margin-bottom: 30px;
          @media screen and (max-width: 1399px) {
            font-size: 26px;
            line-height: 32px;
            margin-bottom: 25px;
          }
          @media screen and (max-width: 1199px) {
            font-size: 24px;
            line-height: 32px;
            margin-bottom: 20px;
          }
          @media screen and (max-width: 991px) {
            font-size: 20px;
            line-height: 26px;
          }
          @media screen and (max-width: 767px) {
            font-size: 18px;
            line-height: 26px;
          }
        }
      }
      .search-block-custom {
        padding: 50px 150px;
        position: relative;
        width: 100%;
        @media screen and (max-width: 1399px) {
          padding: 40px 15px 30px;
        }
        @media screen and (max-width: 991px) {
          padding: 40px 15px 15px;
        }
        .rounded-pill {
          height: 70px;
          border-radius: 10px !important;
          font-family: "Mulish", serif;
          font-weight: 400;
          font-size: 20px;
          border-color: rgba(0, 0, 0, 0.2);
          padding: 0px 90px;
          @media screen and (max-width: 1199px) {
            height: 60px;
            font-size: 16px;
            padding: 0px 65px;
          }
          @media screen and (max-width: 767px) {
            height: 45px;
            font-size: 14px;
            padding: 0px 50px;
          }
        }
        button {
          top: 63px;
          position: absolute;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          border: none;
          left: 170px;
          background-color: rgba(0, 0, 0, 0.1);
          @media screen and (max-width: 1399px) {
            left: 25px;
            top: 53px;
          }
          @media screen and (max-width: 1199px) {
            width: 40px;
            height: 40px;
            top: 51px;
            left: 25px;
          }
          @media screen and (max-width: 767px) {
            width: 30px;
            height: 30px;
            top: 48px;
            svg {
              width: 13px;
            }
          }
        }
      }
      .trigger-block-search-flex {
        display: flex;
        margin: 0px -15px;
        flex-wrap: wrap;
        width: 80%;
        @media screen and (max-width: 991px) {
          width: 100%;
        }
        @media screen and (max-width: 767px) {
          margin: 0px -5px;
        }
        .common-box-bg-all {
          padding: 20px;
          background-color: #fff;
          box-shadow: 0px 10px 20px 10px rgba(0, 0, 0, 0.04);
          border-radius: 20px;
          font-family: "Mulish", serif;
        }
        .library-img-container-main-inner {
          width: 25%;
          padding: 0px 15px 30px;
          @media screen and (max-width: 767px) {
            width: 33.33%;
            padding: 0px 5px 10px;
          }
          .library-img-container-main {
            height: 100%;
            width: 100%;
            max-width: 100%;
            .library-nav {
              height: auto;
              padding: 20px !important;
              border: none !important;
              border: 1px solid transparent !important;
              width: 100%;
              @media screen and (max-width: 1199px) {
                padding: 15px !important;
              }
              @media screen and (max-width: 991px) {
                padding: 10px !important;
              }
              @media screen and (max-width: 767px) {
                padding: 5px !important;
                border-radius: 10px;
                height: 100%;
              }
              &:hover {
                border-color: #c00000 !important;
                .library-img-container-inner {
                  .title-one,
                  .title-two {
                    color: #c00;
                  }
                }
              }
              .library-img-container {
                padding: 0px;
                background: transparent;
                border: none !important;
                box-shadow: none;
                margin: 0px;
                border-radius: 0px;
              }
              .library-img-box {
                width: 100%;
                height: 220px;
                border: none;
                background: transparent;
                margin-bottom: 20px;
                @media screen and (max-width: 1199px) {
                  height: 130px;
                  margin-bottom: 15px;
                }
                @media screen and (max-width: 991px) {
                  height: 100px;
                  margin-bottom: 15px;
                }
                @media screen and (max-width: 767px) {
                  height: 70px;
                  margin-bottom: 5px;
                }
              }
              .lock-overlay {
                width: 100%;
                svg {
                  @media screen and (max-width: 767px) {
                    width: 15px;
                  }
                }
                .lock-text-inner {
                  margin-top: 0px !important;

                  @media screen and (max-width: 767px) {
                    font-size: 10px !important;
                  }
                }
              }
            }
            .library-img-container-inner {
              @media screen and (max-width: 767px) {
                height: auto;
              }
              .title-one {
                font-size: 16px;
                line-height: 20px;
                @media screen and (max-width: 991px) {
                  font-size: 13px;
                  line-height: 18px;
                  word-wrap: break-word;
                  .title-two {
                    font-size: 10px;
                  }
                }
                &.pt-block {
                  padding-top: 15px;
                }
                @media screen and (max-width: 767px) {
                  font-size: 10px;
                  line-height: 16px;
                  .title-two {
                    font-size: 7px;
                  }
                }
              }
              .title-two {
                @media screen and (max-width: 991px) {
                  font-size: 10px;
                }
                @media screen and (max-width: 767px) {
                  font-size: 7px;
                }
              }
            }
          }
        }
      }
    }
  }
`;
